// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:48.459Z
// Property: Mountain Village Apts. (ID: 6767906449165612)
// Collections: 33 amenities, 3 floorplans (live), 21 photos, 65 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165612",
  "property_external_id": "wfczxkl",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/mountain-village-apts-el-paso-tx/wfczxkl/",
  "property_google_business_url": "https://www.google.com/maps/place/Mountain+Village/data=!4m2!3m1!1s0x0:0x621b2d1ef6cd1ca4?sa=X&ved=2ahUKEwjn__-o-7ySAxW7nCYFHY08Lu8Q_BJ6BAg2EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mountain-village-apts.",
  "property_name": "Mountain Village Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/mountain-village-apts/",
  "property_domain": null,
  "property_address": "5890 Bandolero Drive",
  "property_full_address": "5890 Bandolero Drive, El Paso, TX, 79912",
  "property_address_1": "5890 Bandolero Drive",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79912",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Thunderbird",
  "property_address_latitude": "31.8565",
  "property_address_longitude": "-106.5172",
  "property_email": "mountainvillage@caseusa.com",
  "property_phone": "(915) 284-8916",
  "property_call_tracking_phone": "844-645-4686",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Mountain Village Apts. in El Paso, enjoy spacious one and two-bedroom floor plans tailored for comfort. Indulge in resort-style amenities like our sparkling pool, fitness center, and a vibrant clubhouse. With pet-friendly features and serene outdoor spaces, your ideal home awaits. Start your journey to a new lifestyle today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Mountain Village Apts., your premier destination for comfortable living in beautiful El Paso, Texas. Our thoughtfully designed community offers a variety of spacious floor plans, including one and two-bedroom apartments, perfect for every lifestyle. Embrace a life of leisure with our extensive list of amenities that cater to your every need. Dive into relaxation at our resort-style pool, stay fit at our fully-equipped fitness center, or enjoy fun family gatherings at our playground and grill picnic area.\n\nExperience convenience with on-site laundry facilities, package service, and high-speed Wi-Fi. Our dedicated property management team is here to provide exceptional service, along with on-site maintenance for your peace of mind. Pet lovers will appreciate our pet care services, pet play area, and dog park, ensuring your furry friends feel right at home.\n\nEach apartment features essential amenities such as air conditioning, modern kitchens with dishwashers and microwaves, spacious walk-in closets, and cozy fireplaces. Enjoy the freedom of a smoke-free environment along with the advantage of 24-hour access and cable readiness. \n\nLocated in a vibrant community, Mountain Village Apts. offers everything you need to enjoy a relaxed and fulfilling lifestyle. Whether you're seeking a comfortable one-bedroom retreat or a spacious two-bedroom home, you’ll find the perfect fit here.\n\nDon’t miss out on the opportunity to elevate your living experience. Find your new home today—browse our availability or schedule a tour to visit our welcoming community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-da81-71cf-b420-8400aa0187a6.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment complex with mountains in the background.",
    "public_id": "019cfb43-da81-71cf-b420-8400aa0187a6",
    "storage_key": "property/6767906449165612/019cfb43-da81-71cf-b420-8400aa0187a6.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "288",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.65277777777779",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Pets from 1-80 lbs",
  "property_pet_policy_description": "Above applies to Pets from 1-80 lbs",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://mountainvillageapartmentselpaso.securecafe.com/onlineleasing/mountain-village-apts/floorplans.aspx",
  "property_resident_portal_url": "https://mountainvillageapartmentselpaso.securecafe.com/residentservices/mountain-village-apts/userlogin.aspx",
  "property_apply_now_url": "https://mountainvillageapartmentselpaso.securecafe.com/onlineleasing/mountain-village-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-cf5d-724b-85f2-0e595411e842.webp",
  "property_primary_logo_media": {
    "alt_text": "Mountain Village Apartment Homes logo.",
    "public_id": "019cfb42-cf5d-724b-85f2-0e595411e842",
    "storage_key": "property/6767906449165612/019cfb42-cf5d-724b-85f2-0e595411e842.webp",
    "width": 550,
    "height": 180
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-bba8-7513-9c92-a65974d425ec.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb43-bba8-7513-9c92-a65974d425ec",
    "storage_key": "property/6767906449165612/019cfb43-bba8-7513-9c92-a65974d425ec.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-f68d-76d3-9e2d-253e65104242.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Mountain Village Apartment Homes logo.",
    "public_id": "019cfb43-f68d-76d3-9e2d-253e65104242",
    "storage_key": "property/6767906449165612/019cfb43-f68d-76d3-9e2d-253e65104242.webp",
    "width": 550,
    "height": 180
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb44-0657-779b-97e6-c4a5c2c4746a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Mountain Village Apartment Homes logo with a mountain peak icon.",
    "public_id": "019cfb44-0657-779b-97e6-c4a5c2c4746a",
    "storage_key": "property/6767906449165612/019cfb44-0657-779b-97e6-c4a5c2c4746a.webp",
    "width": 550,
    "height": 180
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#504942",
  "property_secondary_color": "#ccc5bd",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#845950",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "700 - 700",
  "property_sqft_min": "700",
  "property_sqft_max": "700",
  "property_price_range": "1025 - 1025",
  "property_price_min": "1025",
  "property_price_max": "1025",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/photo.php?fbid=1148896236956538&id=100055085185585&set=a.599452601900907",
  "property_instagram_url": "https://www.instagram.com/mountain_village_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJvzuqBjRW54YRpBzN9h4tG2I",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/mountain-village-el-paso",
  "property_tiktok_url": "https://www.tiktok.com/@mountainvillageapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Mountain Village Apts.",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Home Here",
  "property_home_amenities_blurb": "Welcome to Mountain Village Apts. in vibrant El Paso, Texas! With a range of thoughtfully designed one and two-bedroom floor plans, you'll find the perfect space to call home. Enjoy resort-style amenities like our shimmering pool, modern fitness center, and a dog park for your furry friends.",
  "property_home_floorplans_blurb": "At Mountain Village Apts. in El Paso, Texas, comfort meets style in our thoughtfully designed one and two-bedroom apartments. With stunning views and modern amenities, each home is a retreat. Browse our available options to find the floor plan that perfectly suits your lifestyle and elevate your living experience today!",
  "property_home_gallery_blurb": "At Mountain Village Apts. in El Paso, your perfect home awaits. Choose from thoughtfully designed one and two-bedroom floor plans featuring modern amenities like a refreshing pool, fitness center, and pet-friendly spaces. With on-site management and hassle-free 24-hour access, envision the lifestyle you deserve—make it a reality today!",
  "property_home_neighborhood_blurb": "At Mountain Village Apts. in El Paso, enjoy spacious one- and two-bedroom floor plans nestled near the vibrant Franklin Mountains State Park and the engaging Urban Air Trampoline and Adventure Park. Experience a community enriched by culture, outdoor spaces, and local attractions that elevate your lifestyle in every season.",
  "property_home_reviews_blurb": "At Mountain Village Apts. in El Paso, our residents rave about the exceptional service and warm community atmosphere. One resident expresses, “The staff is super friendly,” emphasizing the quick and efficient maintenance. With inviting amenities and a welcoming environment, you’re sure to feel right at home here!",
  "property_neighborhood_blurb": "Nestled in vibrant El Paso, Mountain Village Apts. offers easy access to local treasures like Franklin Mountains State Park and the University of Texas at El Paso. With nearby parks, fitness centers, and shopping options, your new home is just moments away from adventure and convenience. Dive into the neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Mountain Village Apts. in El Paso, Texas, the perfect blend of comfort and convenience awaits. Picture yourself lounging by the sparkling pool, enjoying the fitness center, or hosting friends at the grilling area. With pet-friendly spaces and stylish one and two-bedroom layouts, this community caters to your every need.",
  "property_applynow_blurb": "Welcome to Mountain Village Apts., where comfort meets convenience in sunny El Paso! Choose from our spacious one and two-bedroom floor plans, and enjoy top-notch amenities like a sparkling pool, fitness center, and pet-friendly spaces. Ready to elevate your lifestyle? Find your new home and lease online today!",
  "property_contactus_blurb": "At Mountain Village Apts. in El Paso, Texas, find your perfect sanctuary with our thoughtfully designed one and two-bedroom floor plans. Embrace the serene surroundings and modern amenities that elevate your lifestyle. Have questions? Our friendly leasing team is here to assist—reach out today and let’s start your journey!",
  "property_faqs_blurb": "At Mountain Village Apts. in El Paso, your perfect home awaits! With thoughtfully designed floor plans ranging from cozy one-bedroom retreats to spacious two-bedroom homes, our community caters to every lifestyle. Curious about life at Mountain Village? Visit our FAQs page for insights into your future living experience.",
  "property_floorplans_blurb": "At Mountain Village Apts. in sunny El Paso, Texas, our thoughtfully designed one and two-bedroom floor plans offer a harmonious blend of comfort and style. Each space is tailored for modern living, ensuring you feel right at home. Browse our available apartment homes and find your perfect fit today!",
  "property_gallery_blurb": "At Mountain Village Apts. in El Paso, Texas, vibrant living awaits amidst stunning landscapes. Choose from spacious one or two-bedroom floor plans, then relax by the pool, unwind in the clubhouse, or enjoy the dog park. Picture yourself thriving in a community designed for comfort and convenience!",
  "property_interactivemap_blurb": "At Mountain Village Apts. in El Paso, your ideal home awaits with spacious one and two-bedroom layouts. Enjoy a lifestyle enriched by amenities like a refreshing pool, fitness center, and a dog park. Dive into our interactive community map to find your perfect apartment today!",
  "property_pets_blurb": "Nestled in the heart of El Paso, Mountain Village Apts. offers a serene escape with stunning mountain views. Enjoy spacious living and pet-friendly amenities tailored for furry friends up to 80 lbs. Embrace a lifestyle where comfort meets adventure, all within a vibrant community that reflects the beauty of Texas living.",
  "property_referafriend_blurb": "At Mountain Village Apts. in El Paso, Texas, great friends make great neighbors! With spacious one and two-bedroom floor plans tailored for your comfort, our community is the perfect place to call home. Refer a friend today and embrace a vibrant lifestyle surrounded by those you cherish!",
  "property_residentaccess_blurb": "At Mountain Village Apts. in El Paso, Texas, your comfort is our priority. Choose from our thoughtfully designed one and two-bedroom floor plans, perfectly suited for every lifestyle. Unlock a seamless living experience by accessing your resident portal to manage rent, schedule maintenance, and connect with your community today!",
  "property_reviews_blurb": "At Mountain Village Apts. in El Paso, our residents rave about their experiences! \"The staff have been extremely friendly,\" and maintenance requests are handled promptly, ensuring your home is always in top shape. Enjoy our inviting pools, grills, and dog park as you settle into your new community!",
  "property_created_at": "1753982386838",
  "property_scheduletour_blurb": "Elevate your lifestyle at Mountain Village Apts. in El Paso, Texas, where spacious one and two-bedroom floor plans meet stunning community amenities. Experience the perfect blend of comfort and community. Ready to see your new home? Schedule a tour today and hear firsthand from our residents about their vibrant living experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Mountain Village Apts. in beautiful El Paso, Texas! Whether you're searching for a cozy one-bedroom or spacious two-bedroom floor plan, we're excited to help you find your perfect home. Our team will be in touch soon to assist you further!",
  "property_virtualtours_blurb": "Step inside Mountain Village Apts. in El Paso, Texas, where spacious one and two-bedroom floor plans await your personal touch. Our inviting community combines comfort and style, offering the perfect backdrop for your next chapter. Ready to see more? Take a virtual tour today and envision your future home!",
  "property_copyright": "2025 All Rights Reserved. Mountain Village Apts.",
  "property_seo_title_home": "Mountain Village Apts. |  Apartments in El Paso, Texas",
  "property_seo_description_home": "Elevate your lifestyle at Mountain Village Apts. in El Paso! Discover amenities, beautiful floor plans, and a community that feels like home.",
  "property_seo_title_floorplans": "Floor Plans | El Paso, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Mountain Village Apts. in El Paso! Choose from stylish one or two-bedroom floor plans. Your perfect home awaits—view now!",
  "property_seo_title_amenities": "Amenities | El Paso, Texas Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Mountain Village Apts. in El Paso! Enjoy the pool, clubhouse, and pet-friendly features. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, Texas",
  "property_seo_description_gallery": "Envision life at Mountain Village Apts. in El Paso! With stunning amenities like a pool, fitness center, and pet-friendly spaces, your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Mountain Village Apts. Apartments",
  "property_seo_description_virtualtours": "Experience El Paso living at Mountain Village Apts. Take a virtual tour of our one and two-bedroom floor plans today—your ideal home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Mountain Village Apts. Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Mountain Village Apts. in El Paso! Explore floor plans and amenities with our interactive map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, Texas",
  "property_seo_description_neighborhood": "Uncover the charm of El Paso near Mountain Village Apts. Dive into local favorites, parks, and attractions that make our community a vibrant home.",
  "property_seo_title_contact": "Contact Us | Mountain Village Apts.",
  "property_seo_description_contact": "Experience the charm of Mountain Village Apts. in El Paso! Have questions? Reach out to our leasing team today and find your perfect one or two-bedroom home!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, Texas",
  "property_seo_description_faqs": "Get answers to your burning questions about Mountain Village Apts. in El Paso. Discover our amenities, floor plans, and more. Your ideal home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, Texas",
  "property_seo_description_reviews": "Uncover the charm of Mountain Village Apts. in El Paso! Hear from residents about their vibrant lives here, complete with stellar amenities and cozy homes.",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, Texas",
  "property_seo_description_applynow": "Elevate your lifestyle at Mountain Village Apts. in El Paso! Enjoy spacious one and two-bedroom homes with premier amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Mountain Village Apts.",
  "property_seo_description_residentaccess": "Stay connected at Mountain Village Apts in El Paso! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Mountain Village Apts.",
  "property_seo_description_referafriend": "Refer a friend to Mountain Village Apts in El Paso! Great friends make great neighbors—enjoy vibrant living and community perks together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Mountain Village Apts.",
  "property_seo_description_scheduletour": "Experience the charm of Mountain Village Apts. in El Paso. Schedule a tour today and find your perfect home surrounded by scenic beauty and modern amenities!",
  "property_seo_title_privacy": "Privacy Policy | Mountain Village Apts.",
  "property_seo_description_privacy": "Your privacy matters at Mountain Village Apts. in El Paso. Review our commitment to safeguarding your data and ensuring a secure living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Mountain Village Apts.",
  "property_seo_description_accessibility": "At Mountain Village Apts in El Paso, we embrace digital inclusion. Explore our commitment to accessibility and ensure everyone feels at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Mountain Village Apts.",
  "property_seo_description_sitemap": "Uncover every corner of Mountain Village Apts in El Paso! Navigate our sitemap to find your ideal home in a vibrant community surrounded by stunning views.",
  "property_seo_title_thankyou": "Thank You | Mountain Village Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out! Your inquiry at Mountain Village Apts in El Paso is important to us. A team member will connect with you soon—stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865410085",
  "amenities": [
    {
      "id": "ec_774def71a51833c85f86fd09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396763",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_141f1a169f82d0a3292bef0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396764",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a708c5ddeacdd6c58518a99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396765",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_270deb8fecdcd5e4f5ee67db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396766",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_694053688d23a1d0c6c180ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396767",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0d439b9d960beb9494e412a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396768",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0826b5409ea70852549f9ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396769",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56f0fe3976ff43403176250d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396770",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_585706635e18de89d9a0a5be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396771",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ad9574f00b4583404450442",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396772",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4345d07645afa5390656a2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396773",
      "title": "Beautiful Mountain Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e360322c46a8da01362e608d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396774",
      "title": "On Site Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c23e8deddebe1be9862e1e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396775",
      "title": "Self-Service Pet Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32c6eedeec96f3d136fda634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396776",
      "title": "Professional Maintenance Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_355c7458726cf3787d1ce433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396777",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9480970dc22f1ff2d6eca8ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396778",
      "title": "Online Rental Payments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b5419cd02f2a518063befb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396779",
      "title": "Spaciously Designed Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b7297655d925acd9164ec25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396780",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61039aaa7898fb82be233206",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127396781",
      "title": "Corporate Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_008b1b58b72382419bc30a2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "128042540",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f480010c9f92712f1b09ddf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398252",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc48165207566155ba3565b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398253",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e29754fffbe184b4c642aee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398254",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd43dc833750d0a4138a7763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398255",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_764ffa21549079221d3eec95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398256",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8bcb01caf30979f3fc8218bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398257",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3f149de664b0cb569a99e86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398258",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6480951f3b826af5ac91051b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398259",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d09e3cbad6f94833b5987f97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398260",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4a6b7feefebc7068aa8b0d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398261",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09e6d010a6d45981e9abbf6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398262",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c62997447e8db2d0eb855562",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398263",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8c51ea5e87116a91e45353d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "yardi",
      "external_id": "127398264",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_77308a9f-3b06-4130-b068-06917d606f06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-3f80-7519-811d-bb5f15b4cc52.webp",
      "image_media": {
        "alt_text": "Mountain Village Apartment Homes monument sign",
        "public_id": "019d20af-3f80-7519-811d-bb5f15b4cc52",
        "storage_key": "property/6767906449165612/019d20af-3f80-7519-811d-bb5f15b4cc52.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to Mountain Village Apartment Homes. This exterior monument sign features the property's name and logo, set against a brick structure with landscaping.",
      "link": "",
      "alt_text": "Mountain Village Apartment Homes monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-5c58-714d-9f84-b6b6be2d292e.webp"
    },
    {
      "id": "custom_a346c11a-fb02-43e2-852d-561206b6dc63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-3f75-736f-94ec-bb10892b9c56.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings nestled in a hillside with mountains in the background.",
        "public_id": "019d20af-3f75-736f-94ec-bb10892b9c56",
        "storage_key": "property/6767906449165612/019d20af-3f75-736f-94ec-bb10892b9c56.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Experience comfortable living in this scenic apartment community, surrounded by natural beauty and offering convenient amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings nestled in a hillside with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-5fc3-712e-8882-b455c4956771.webp"
    },
    {
      "id": "custom_a15ba83e-57ca-4bd2-8214-bb14d7369a80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-3efb-73c5-a758-97766401bf06.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including hoops and a tunnel.",
        "public_id": "019d20af-3efb-73c5-a758-97766401bf06",
        "storage_key": "property/6767906449165612/019d20af-3efb-73c5-a758-97766401bf06.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Let your furry friends play and exercise in our dedicated dog park, complete with fun agility equipment.",
      "link": "",
      "alt_text": "Dog park with agility equipment including hoops and a tunnel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-6003-765c-a1a9-06135124f22f.webp"
    },
    {
      "id": "custom_e02270d1-b9c7-46e8-a3a4-c20142f7fa19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-3efc-7329-8725-7266d838ddd2.webp",
      "image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage and landscaping.",
        "public_id": "019d20af-3efc-7329-8725-7266d838ddd2",
        "storage_key": "property/6767906449165612/019d20af-3efc-7329-8725-7266d838ddd2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to Mountain Village Apartment Homes, where our leasing office awaits to assist you. Explore our community and find your perfect home.",
      "link": "",
      "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-6003-765c-a1a9-0a5da8096dec.webp"
    },
    {
      "id": "custom_a11a8187-12e9-4285-bcba-daa4eca8ecce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-4aae-77fa-b058-4277ced62d28.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and shaded seating areas.",
        "public_id": "019d20af-4aae-77fa-b058-4277ced62d28",
        "storage_key": "property/6767906449165612/019d20af-4aae-77fa-b058-4277ced62d28.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing or soaking up the sun. Lounge chairs and shaded seating provide ultimate comfort.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and shaded seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165612/019cfb42-cfee-704e-b2cd-f440a1034530.webp"
    },
    {
      "id": "custom_1b14dd48-9169-488a-aab5-c74f2e9af71a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-4a18-716d-b5ba-66505a2e6ec9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d20af-4a18-716d-b5ba-66505a2e6ec9",
        "storage_key": "property/6767906449165612/019d20af-4a18-716d-b5ba-66505a2e6ec9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-5cfd-72cf-b055-d66324ca7f68.webp"
    },
    {
      "id": "custom_112c63da-d77d-4488-8bdd-705e897d9aef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-4b51-752e-af64-211857205885.webp",
      "image_media": {
        "alt_text": "Playground with red and blue structures under a blue sunshade.",
        "public_id": "019d20af-4b51-752e-af64-211857205885",
        "storage_key": "property/6767906449165612/019d20af-4b51-752e-af64-211857205885.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Children's playground featuring a large, colorful play structure with slides and climbing elements, set on a sandy surface and shaded by a large blue canopy.",
      "link": "",
      "alt_text": "Playground with red and blue structures under a blue sunshade.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-5d40-7351-b7eb-162f514d51c6.webp"
    },
    {
      "id": "custom_33dab35d-75ab-40a7-ac85-3c4647ec5b86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-4bb3-71b5-bdd8-6a29783e87c8.webp",
      "image_media": {
        "alt_text": "Dog washing station with stairs and showerheads,",
        "public_id": "019d20af-4bb3-71b5-bdd8-6a29783e87c8",
        "storage_key": "property/6767906449165612/019d20af-4bb3-71b5-bdd8-6a29783e87c8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Community dog washing station with convenient stairs and showerheads for easy grooming.",
      "link": "",
      "alt_text": "Dog washing station with stairs and showerheads,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-6023-754b-b672-a76c251cbf6c.webp"
    },
    {
      "id": "custom_b8e4e20b-28c1-4e10-abc6-907a1101b112",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-55d6-721f-a95e-70afb8c1ca2c.webp",
      "image_media": {
        "alt_text": "Gym with treadmills and elliptical machines",
        "public_id": "019d20af-55d6-721f-a95e-70afb8c1ca2c",
        "storage_key": "property/6767906449165612/019d20af-55d6-721f-a95e-70afb8c1ca2c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, elliptical machines, and weight training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills and elliptical machines",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165612/019cfb42-cfb0-7187-bad4-2f122a3b90f5.webp"
    },
    {
      "id": "custom_90a0cbdf-0e4b-408b-b1de-7e9a3a24efa5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-5956-7718-a8ee-737c89207022.webp",
      "image_media": {
        "alt_text": "Office area with a desk, computer, printer, and water cooler.",
        "public_id": "019d20af-5956-7718-a8ee-737c89207022",
        "storage_key": "property/6767906449165612/019d20af-5956-7718-a8ee-737c89207022.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "A functional office space featuring a computer, printer, and water cooler, perfect for residents needing to work or print documents.",
      "link": "",
      "alt_text": "Office area with a desk, computer, printer, and water cooler.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165612/019cfb42-cfe2-7706-8abe-b76cbc0123bd.webp"
    },
    {
      "id": "custom_5569a06d-3a6a-454c-9502-5761789acec8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-59d2-7739-968f-8106735b2ca0.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, coffee table, armchair, fireplace, and artwork.",
        "public_id": "019d20af-59d2-7739-968f-8106735b2ca0",
        "storage_key": "property/6767906449165612/019d20af-59d2-7739-968f-8106735b2ca0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable blue sofa, elegant coffee table, and a decorative fireplace. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with blue sofa, coffee table, armchair, fireplace, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-5c4f-7452-aa21-ef26f881f901.webp"
    },
    {
      "id": "custom_6cd10369-4d3b-4ebd-878d-2bd0833de3d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-5cf0-746b-961b-f81aceb3b817.webp",
      "image_media": {
        "alt_text": "Bedroom with a green bed, blue and green pillows, and a toy astronaut. There is a wooden headboard with books and a lamp.",
        "public_id": "019d20af-5cf0-746b-961b-f81aceb3b817",
        "storage_key": "property/6767906449165612/019d20af-5cf0-746b-961b-f81aceb3b817.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A comfortable bedroom featuring a plush green bed, accented with decorative pillows and a playful toy astronaut. The space includes a stylish wooden headboard with integrated lighting and a display shelf for books.",
      "link": "",
      "alt_text": "Bedroom with a green bed, blue and green pillows, and a toy astronaut. There is a wooden headboard with books and a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-5bfa-754a-916d-e1a70d53926d.webp"
    },
    {
      "id": "custom_47f9e50e-793e-44da-be6b-a3cac556d7b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-606d-775e-aba1-24be9c9d93da.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and shower curtain.",
        "public_id": "019d20af-606d-775e-aba1-24be9c9d93da",
        "storage_key": "property/6767906449165612/019d20af-606d-775e-aba1-24be9c9d93da.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "This bathroom features a vanity with a sink, ample counter space, and storage below. A toilet and a shower with a striped curtain complete the space.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, toilet, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-6db7-7797-a514-475f5df64c02.webp"
    },
    {
      "id": "custom_a452730c-0d72-41ca-b9ac-5802b76328ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-63ce-7026-82e5-c28a2a243b18.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, two chairs, and a view of the kitchen.",
        "public_id": "019d20af-63ce-7026-82e5-c28a2a243b18",
        "storage_key": "property/6767906449165612/019d20af-63ce-7026-82e5-c28a2a243b18.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, featuring a stylish round table and comfortable seating. The open pass-through to the kitchen makes entertaining a breeze.",
      "link": "",
      "alt_text": "Dining area with a round table, two chairs, and a view of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-7521-754c-8402-6da0d2160be2.webp"
    },
    {
      "id": "custom_2c251cfd-70c8-4088-87c8-0875bd17afc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-64eb-716d-9c9a-93c53be00ef0.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, double sink, and granite countertops.",
        "public_id": "019d20af-64eb-716d-9c9a-93c53be00ef0",
        "storage_key": "property/6767906449165612/019d20af-64eb-716d-9c9a-93c53be00ef0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring a full-size refrigerator, microwave, dishwasher, electric stove, double sink, and ample cabinet space.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wood cabinets, double sink, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-7540-771b-b512-b96f62cc5f99.webp"
    },
    {
      "id": "custom_1c65af9f-3e50-445e-931f-2c65c4f8b424",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-6ad5-71c4-bf7a-d62982abefde.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wooden cabinets, and a double sink.",
        "public_id": "019d20af-6ad5-71c4-bf7a-d62982abefde",
        "storage_key": "property/6767906449165612/019d20af-6ad5-71c4-bf7a-d62982abefde.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Well-lit kitchen featuring white appliances including a microwave and oven, ample wooden cabinetry, and a spacious double sink with a decorative mirror above.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wooden cabinets, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-774c-7469-bc4e-f87782c710cf.webp"
    },
    {
      "id": "custom_20bfd4d4-17a3-4449-ae27-024d3a5ef956",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-6a63-7179-a411-83d6a89d59d8.webp",
      "image_media": {
        "alt_text": "Kitchen with white stove, microwave, and dual sink.",
        "public_id": "019d20af-6a63-7179-a411-83d6a89d59d8",
        "storage_key": "property/6767906449165612/019d20af-6a63-7179-a411-83d6a89d59d8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring a white stove, microwave, ample cabinet space, and a dual sink. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white stove, microwave, and dual sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-7b0d-7333-b924-a60b4b8ae5f5.webp"
    },
    {
      "id": "custom_0b1cef29-c3d8-4c07-972a-398809d318e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-6eba-764e-9039-a62514bc7c14.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, nightstands, and a ceiling fan.",
        "public_id": "019d20af-6eba-764e-9039-a62514bc7c14",
        "storage_key": "property/6767906449165612/019d20af-6eba-764e-9039-a62514bc7c14.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom featuring a comfortable king-sized bed, stylish nightstands, and a cooling ceiling fan for ultimate comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-aca8-764a-ad0f-4096f8aa906b.webp"
    },
    {
      "id": "custom_3a741e7f-38a0-448e-8fbf-675eaf3ce7be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-6ff7-7008-80f1-1d11c899b711.webp",
      "image_media": {
        "alt_text": "Modern living room with open kitchen, bar seating, and a mounted television.",
        "public_id": "019d20af-6ff7-7008-80f1-1d11c899b711",
        "storage_key": "property/6767906449165612/019d20af-6ff7-7008-80f1-1d11c899b711.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a comfortable sofa, a contemporary TV console, and an adjacent kitchen with bar stools, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with open kitchen, bar seating, and a mounted television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-7f03-7636-af8c-02ee1ce24114.webp"
    },
    {
      "id": "custom_0d97433c-4deb-4fa7-b3e0-e4ad684900e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-7772-7698-872a-14ba34fbee8c.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, vanity, and shower with white ruffled curtain.",
        "public_id": "019d20af-7772-7698-872a-14ba34fbee8c",
        "storage_key": "property/6767906449165612/019d20af-7772-7698-872a-14ba34fbee8c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Well-appointed bathroom featuring a toilet, vanity with sink, and a shower/tub combo with a decorative curtain.",
      "link": "",
      "alt_text": "Bathroom with toilet, sink, vanity, and shower with white ruffled curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-7ef0-758d-897f-1a26662aabbd.webp"
    },
    {
      "id": "custom_d8bc34ff-205b-4f70-ab3c-560d3238f92c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d20af-7869-757d-8b50-bb03fefeb4f1.webp",
      "image_media": {
        "alt_text": "Living Room with Fireplace",
        "public_id": "019d20af-7869-757d-8b50-bb03fefeb4f1",
        "storage_key": "property/6767906449165612/019d20af-7869-757d-8b50-bb03fefeb4f1.webp",
        "width": 2000,
        "height": 500
      },
      "title": "Apartment",
      "description": "Living Room with Fireplace",
      "link": "",
      "alt_text": "Living Room with Fireplace",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165612/019cfb42-d827-70a8-854a-026a1182dbe7.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e27d1fea-06a5-4a07-9eb1-61a69f18de38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Topgolf El Paso",
      "poi_type": "Restaurants",
      "poi_address": "365 Vin Rambla Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Golf-themed entertainment venue combining a driving range with dining and cocktails.",
      "poi_long_description": "People say this restaurant offers fun games, good food, and a variety of drink options. They highlight the lively atmosphere and the friendly, attentive staff. They also like the great party packages and the value, especially on Tuesdays when golfing is half price.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-2dc7-7458-8479-2e33054d0eb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2dc7-7458-8479-2e33054d0eb4",
        "storage_key": "property/6767906449165612/019d2709-2dc7-7458-8479-2e33054d0eb4.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://topgolf.com/us/el-paso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10477886874640848166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-el-paso",
      "poi_latitude": "31.8107961",
      "poi_longitude": "-106.5250411",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-845-9028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c5d-71ce-80fe-3aee80c2cca9",
        "storage_key": "property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxkkkflX54YRJhWyJ5nuaJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_105c62d8-6fed-4374-98bc-9590d212dced",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5010 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "Casual chain steakhouse specializing in beef, burgers, ribs, and chicken.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and loaded mashed potatoes, and the rolls with cinnamon butter are amazing. They highlight the generous portions, good value, and lively atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-2e36-740a-9d5a-e3f9dd5ac4c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2e36-740a-9d5a-e3f9dd5ac4c1",
        "storage_key": "property/6767906449165612/019d2709-2e36-740a-9d5a-e3f9dd5ac4c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/el-paso-n-desert-blvd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=2594805389550251164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.8404434",
      "poi_longitude": "-106.5685133",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-832-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c5d-71ce-80fe-3aee80c2cca9",
        "storage_key": "property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ684Xlln43YYRnGxpAcGZAiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_5eb50ebd-a3f3-4303-a5cf-d1139631379f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "2201 N Mesa St, El Paso, TX 79902, USA",
      "poi_short_description": "Restaurant chain known for its burgers (including those with jalapenos or green chiles), fries and onion rings, plus shakes.",
      "poi_long_description": "People say this fast food restaurant serves delicious burgers. They also highlight the fast and courteous service.\n\nOther reviews mention the drive thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-2e61-76ed-9fc9-c8d0b51bff51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2e61-76ed-9fc9-c8d0b51bff51",
        "storage_key": "property/6767906449165612/019d2709-2e61-76ed-9fc9-c8d0b51bff51.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.whataburger.com/tx/el-paso/2201-n-mesa-st.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=9737941307269630187&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "31.7734029",
      "poi_longitude": "-106.5004915",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 915-533-8338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c5d-71ce-80fe-3aee80c2cca9",
        "storage_key": "property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9pgYlpY54YR68hobwYeJIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_bc2e8e8a-b934-474c-a896-a6e6f836b89b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "7420 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Buffet chain restaurant serving steaks and fried chicken alongside a salad bar and desserts.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of food, including steak, ribs, chicken, fish, pork, salad, and dessert. They also highlight the family-friendly atmosphere and the great value for the price, especially during lunch hours.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-2df2-755f-b48d-4594534bbef3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2df2-755f-b48d-4594534bbef3",
        "storage_key": "property/6767906449165612/019d2709-2df2-755f-b48d-4594534bbef3.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/538/golden-corral-mesa-street?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=538",
      "poi_directions_map_url": "https://maps.google.com/?cid=324338960513468043&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "31.8381721",
      "poi_longitude": "-106.5600825",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-833-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c5d-71ce-80fe-3aee80c2cca9",
        "storage_key": "property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQrSoF343YYRi4Y58JBIgAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_e9581ef5-caef-43e1-8b35-dfdae34279ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2031 N Mesa St, El Paso, TX 79902, USA",
      "poi_short_description": "Fast-food joint dishing up chicken fingers, sandwiches, fries and coleslaw meals with a signature sauce alongside a drive-thru option.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and Texas toast. They highlight the food is consistently hot and fresh, and the dipping sauce is delicious. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-331b-729b-bd44-0a6855142205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-331b-729b-bd44-0a6855142205",
        "storage_key": "property/6767906449165612/019d2709-331b-729b-bd44-0a6855142205.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/el-paso/2031-north-mesa-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=2350317631809797510&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "31.772112",
      "poi_longitude": "-106.4993551",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 915-351-4303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c5d-71ce-80fe-3aee80c2cca9",
        "storage_key": "property/6767906449165612/019d2709-5c5d-71ce-80fe-3aee80c2cca9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrcsWo1BY54YRhj1cAW8BniA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_447cc3ad-1186-40c8-9f9c-1e2f52eb83b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "The Outlet Shoppes at El Paso",
      "poi_type": "Shopping & Retail",
      "poi_address": "7051 S Desert Blvd, Canutillo, TX 79835, USA",
      "poi_short_description": "Outdoor outlet mall featuring 100-plus brand-name shops (Nike, Banana Republic, Kate Spade, Johnston & Murphy).",
      "poi_long_description": "People say this outlet mall offers a wide variety of brand-name stores with good deals and discounts. They highlight the abundant parking, clean facilities, and average food court with a bar. They also like the well-maintained property and convenient location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-32ef-71cc-a81b-2efd87314954.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-32ef-71cc-a81b-2efd87314954",
        "storage_key": "property/6767906449165612/019d2709-32ef-71cc-a81b-2efd87314954.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theoutletshoppesatelpaso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7804044863194317612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-outlet-shoppes-at-el-paso",
      "poi_latitude": "31.9122222",
      "poi_longitude": "-106.5855556",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 915-877-3208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c36-7579-b92f-129ee6bf3469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c36-7579-b92f-129ee6bf3469",
        "storage_key": "property/6767906449165612/019d2709-5c36-7579-b92f-129ee6bf3469.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTVOQPeH-3YYRLMPomXSJTWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_28aa389a-8c26-48fb-9ab9-2d5ec717f501",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Pitt St, El Paso, TX 79912, USA",
      "poi_short_description": "Grocery chain including a bakery, an in-store bar and a salad bar.",
      "poi_long_description": "People say this grocery store offers a wide variety of organic foods, fresh produce, and baked goods, including a popular hot bar and pizza. They highlight the clean and modern atmosphere, and the convenient amenities such as a bread slicer and Amazon return area. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-3397-7115-b903-121a2de02a53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3397-7115-b903-121a2de02a53",
        "storage_key": "property/6767906449165612/019d2709-3397-7115-b903-121a2de02a53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/elpaso?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5575333113701639611&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "31.8340462",
      "poi_longitude": "-106.5480013",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-236-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5be9-74ee-9497-f6d82bb2cb8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5be9-74ee-9497-f6d82bb2cb8a",
        "storage_key": "property/6767906449165612/019d2709-5be9-74ee-9497-f6d82bb2cb8a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj13blm_43YYRu6Wocu2PX00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e27f1235-08e3-4c58-bfea-af5d8034349b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "The Shoppes at Solana",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "One-time Sunland Park Mall now with a variety of national and local retailers, plus a food court and rock-climbing wall.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a good food court. They also highlight the clean restrooms and fun atmosphere, especially during events like fireworks displays.\n\nOther reviews mention the mall can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-3423-7267-820f-1fbc14050af0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3423-7267-820f-1fbc14050af0",
        "storage_key": "property/6767906449165612/019d2709-3423-7267-820f-1fbc14050af0.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "http://theshoppesatsolana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2107962478139008266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shoppes-at-solana",
      "poi_latitude": "31.8144216",
      "poi_longitude": "-106.5440443",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-833-5596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c36-7579-b92f-129ee6bf3469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c36-7579-b92f-129ee6bf3469",
        "storage_key": "property/6767906449165612/019d2709-5c36-7579-b92f-129ee6bf3469.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoWrRgA_43YYRCuVTlbT8QB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4f214979-5fd6-41c2-99c5-71aafec57ce6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7545 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Retailer supplying tools, appliances, building materials, and home improvement items, plus installation services.",
      "poi_long_description": "People say this home improvement store is well-stocked and the staff is helpful and knowledgeable. They also highlight the friendly and attentive service, making it a pleasant shopping experience.\n\nSome reviews mention the wait times for assistance can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-37ae-750b-9245-7be61d60aa35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-37ae-750b-9245-7be61d60aa35",
        "storage_key": "property/6767906449165612/019d2709-37ae-750b-9245-7be61d60aa35.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/West-El-Paso/TX/El-Paso/79912/523?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7694583817001495963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.835826",
      "poi_longitude": "-106.5642035",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-585-2319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c36-7579-b92f-129ee6bf3469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c36-7579-b92f-129ee6bf3469",
        "storage_key": "property/6767906449165612/019d2709-5c36-7579-b92f-129ee6bf3469.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8zsx0lv43YYRm-3XwjanyGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_67df42b7-dcc9-4b25-90bc-ec47ed2aeebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "430 Redd Rd, El Paso, TX 79912, USA",
      "poi_short_description": "Outdoor furniture store, lawn equipment rental service and building materials supplier providing items for home-repair projects.",
      "poi_long_description": "People say this home improvement store offers a wide variety of supplies for home projects. They also highlight the helpfulness of some staff members.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-379a-76f6-91dd-893ed6684c2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-379a-76f6-91dd-893ed6684c2b",
        "storage_key": "property/6767906449165612/019d2709-379a-76f6-91dd-893ed6684c2b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-El-Paso/1152?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1152-_-na-_-0-_-0&y_source=1_MTE4NDM4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5332424068888550467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.861958",
      "poi_longitude": "-106.5726474",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-581-4401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c36-7579-b92f-129ee6bf3469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c36-7579-b92f-129ee6bf3469",
        "storage_key": "property/6767906449165612/019d2709-5c36-7579-b92f-129ee6bf3469.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUewuiOb43YYRQ1zYMXCTAEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a0e008f9-c4a0-4a47-b48a-9d756caf8033",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "University of Texas at El Paso",
      "poi_type": "Education",
      "poi_address": "500 W University Ave, El Paso, TX 79968, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-3853-70ef-a480-eac863a39df1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3853-70ef-a480-eac863a39df1",
        "storage_key": "property/6767906449165612/019d2709-3853-70ef-a480-eac863a39df1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.utep.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15130569928881990844&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-texas-at-el-paso",
      "poi_latitude": "31.7731979",
      "poi_longitude": "-106.5047208",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 915-747-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c10-7059-b1ac-5f75caccec11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c10-7059-b1ac-5f75caccec11",
        "storage_key": "property/6767906449165612/019d2709-5c10-7059-b1ac-5f75caccec11.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ12KA7lpY54YRvOw3ZC-V-tE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c16096d6-6c40-4fe9-940c-049c39ef7bf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "University Library",
      "poi_type": "Education",
      "poi_address": "1900 Wiggins Rd, El Paso, TX 79968, USA",
      "poi_short_description": "University library with free admission and study space, plus a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-3a04-767f-aa8a-3f4ac7b2a9f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3a04-767f-aa8a-3f4ac7b2a9f7",
        "storage_key": "property/6767906449165612/019d2709-3a04-767f-aa8a-3f4ac7b2a9f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utep.edu/library",
      "poi_directions_map_url": "https://maps.google.com/?cid=16419899299576992938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-library",
      "poi_latitude": "31.7673321",
      "poi_longitude": "-106.50472",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-747-5672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5fb6-72d9-8c30-27af483976ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5fb6-72d9-8c30-27af483976ee",
        "storage_key": "property/6767906449165612/019d2709-5fb6-72d9-8c30-27af483976ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7gl1lhY54YRqtT4pmoz3-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e3b52ed5-a923-444a-a1fb-6e5851e8810d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Sun Bowl",
      "poi_type": "Entertainment",
      "poi_address": "2701 Sun Bowl Dr, El Paso, TX 79902, USA",
      "poi_short_description": "Stadium hosting concerts, football games, and Monster Jam events, plus tailgating.",
      "poi_long_description": "People say this stadium hosts a variety of events, including concerts, football games, and Monster Jam. They highlight the beautiful views of the surrounding mountains and the well-maintained facilities, including restrooms and concessions. They also like the spacious seating and the smooth traffic flow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-3c1f-71a3-9e43-0ade580048ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3c1f-71a3-9e43-0ade580048ea",
        "storage_key": "property/6767906449165612/019d2709-3c1f-71a3-9e43-0ade580048ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utepspecialevents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12740333998005602376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sun-bowl",
      "poi_latitude": "31.7733442",
      "poi_longitude": "-106.5079256",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5fd5-777a-9701-81ec8a0837d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5fd5-777a-9701-81ec8a0837d6",
        "storage_key": "property/6767906449165612/019d2709-5fd5-777a-9701-81ec8a0837d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ3x541xY54YRSMj0HkXCzrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_6096d348-151a-4e5c-bea3-55150da70a3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Don Haskins Center",
      "poi_type": "Entertainment",
      "poi_address": "151 Glory Rd, El Paso, TX 79902, USA",
      "poi_short_description": "Arena hosting big concerts and other events with food, drink, and free parking.",
      "poi_long_description": "People say this arena is a great place to attend graduations and concerts, and they appreciate the well-organized events and comfortable temperature inside. They also highlight the ample parking and easy access to the venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-3c64-7138-b8b2-a9ca3d60bf03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3c64-7138-b8b2-a9ca3d60bf03",
        "storage_key": "property/6767906449165612/019d2709-3c64-7138-b8b2-a9ca3d60bf03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utepspecialevents.com/venues/don_haskins_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11992951360778632993&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-haskins-center",
      "poi_latitude": "31.7776195",
      "poi_longitude": "-106.5056719",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 915-747-5481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46MilERY54YRIX-_o7iFb6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_7717e845-dc88-4f46-bd89-ec99530690e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Western Playland",
      "poi_type": "Entertainment",
      "poi_address": "1249 Futurity Dr, Sunland Park, NM 88063, USA",
      "poi_short_description": "Park with rides, drop zones, a ferris wheel, popcorn, and a train.",
      "poi_long_description": "People say this amusement park offers fun rides. They also highlight the friendly staff and clean environment.\n\nOther reviews mention some rides can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-3dc4-7693-bab1-63f7801e712b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3dc4-7693-bab1-63f7801e712b",
        "storage_key": "property/6767906449165612/019d2709-3dc4-7693-bab1-63f7801e712b.webp",
        "width": 1280,
        "height": 732
      },
      "poi_business_url": "http://westernplayland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10683493240736277755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "western-playland",
      "poi_latitude": "31.8023751",
      "poi_longitude": "-106.5597117",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 575-589-3410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuwMSlib43YYR-2Rftn9kQ5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_932b172f-f217-48cb-91e9-1ce3aaba9311",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "801 S Mesa Hills Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Indoor chain entertainment center featuring trampolines, rock climbing, laser tag, and a ropes course.",
      "poi_long_description": "People say this amusement park is a great place for families and birthday parties, with a variety of attractions for kids of all ages. They also highlight the friendly and attentive staff, and the fun, safe atmosphere.\n\nOther reviews mention the food can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-3f17-763c-8f6c-b33ec62e2402.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3f17-763c-8f6c-b33ec62e2402",
        "storage_key": "property/6767906449165612/019d2709-3f17-763c-8f6c-b33ec62e2402.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/texas-west-el-paso/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=9791591556466300534&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "31.81827539999999",
      "poi_longitude": "-106.5405754",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-263-8277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2yyOdb53YYRdlbjfKS44oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_362ad2f2-2ef4-4170-9010-43cfb28a1163",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Jumping World - El Paso",
      "poi_type": "Entertainment",
      "poi_address": "5850 Onix Dr, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of activities, including bowling, jumping, arcade games, and a zip line. They highlight the family-friendly atmosphere, the fun for all ages, and the reasonable prices. They also like the clean facilities and the friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-4189-770c-b350-09c8aa09058f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4189-770c-b350-09c8aa09058f",
        "storage_key": "property/6767906449165612/019d2709-4189-770c-b350-09c8aa09058f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://jwentertainment.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1220633753471461160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jumping-world---el-paso",
      "poi_latitude": "31.8177923",
      "poi_longitude": "-106.5376012",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-910-6378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswg9pLf53YYRKKeEfO6P8BA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_075b92a2-f0c4-4f2f-a90e-8a0be586d7e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Crunch Fitness - El Paso Dyer",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 Dyer St, El Paso, TX 79924, USA",
      "poi_short_description": "Clean, bright, spacious chain gym, featuring treadmills, elliptical trainers, bike trainers and weight machines, plus classes and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and a sauna, and the staff is friendly and welcoming.\n\nOther reviews mention the gym can be crowded and the membership pricing can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-417b-774b-96f7-a5a32d17cbbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-417b-774b-96f7-a5a32d17cbbe",
        "storage_key": "property/6767906449165612/019d2709-417b-774b-96f7-a5a32d17cbbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/el-paso-dyer",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674348033972161344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---el-paso-dyer",
      "poi_latitude": "31.8722149",
      "poi_longitude": "-106.4278235",
      "poi_miles_from_property": "16.3",
      "poi_walking_minutes": "5 hours 57 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 915-455-0044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7aPFYLpR54YRQMtIc6p6PBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7dcefd81-f19a-48df-9fdb-cda9646fe7ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Kinective Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "Modern gym with state-of-the-art machines, spa amenities and fitness classes, plus personal training.",
      "poi_long_description": "People say this fitness center offers a wide variety of classes, including yoga, Pilates, cycling, and Zumba, as well as state-of-the-art equipment and amenities like a sauna, steam room, and massage chairs. They highlight the positive energy, clean facilities, and convenient features such as a rooftop track, a bar, and a mini restaurant with smoothies, bowls, and salads. They also like the friendly and helpful staff, and the sense of community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-42b6-77cb-a342-c81b5739d3c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-42b6-77cb-a342-c81b5739d3c6",
        "storage_key": "property/6767906449165612/019d2709-42b6-77cb-a342-c81b5739d3c6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://kinective.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=844899700064661306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kinective-fitness-club",
      "poi_latitude": "31.8521899",
      "poi_longitude": "-106.5401454",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-260-9895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSrKKj753YYROi8w_cyvuQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_0cec7af4-1854-4dce-ad98-7a3e820a7cf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "813 Sunland Park Dr Ste B, El Paso, TX 79912, USA",
      "poi_short_description": "Retailer for skin, hair, makeup, and fragrance products, including exclusives, plus in-store salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-43f1-7721-9b57-2423d97ff0be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-43f1-7721-9b57-2423d97ff0be",
        "storage_key": "property/6767906449165612/019d2709-43f1-7721-9b57-2423d97ff0be.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/el-paso-tx-303",
      "poi_directions_map_url": "https://maps.google.com/?cid=9506694949814193497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "31.8184478",
      "poi_longitude": "-106.5496002",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-581-0314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL73eNhD43YYRWc2sL7CQ7oM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_39f0f686-bd05-462b-a89e-58162d22deb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs",
      "poi_type": "Health and Wellness",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Premium health club offering classes and training sessions in a welcoming atmosphere featuring fitness equipment and a turf area.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and cardio equipment, as well as group classes like Zumba and yoga. They highlight the friendly and helpful staff, and the welcoming and supportive atmosphere. They also like the clean facilities and the availability of amenities such as showers, saunas, and a daycare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-46c0-73de-aee9-3720c3e5d856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-46c0-73de-aee9-3720c3e5d856",
        "storage_key": "property/6767906449165612/019d2709-46c0-73de-aee9-3720c3e5d856.webp",
        "width": 1026,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/el-paso/sunland-mall/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15276080860203553813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs",
      "poi_latitude": "31.8145396",
      "poi_longitude": "-106.5462017",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-300-1993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1_VFxT53YYRFZSTMJuK_9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d60690e9-55c9-426e-a442-cd8b25d87b6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "725 N Resler Dr, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-4663-75c9-b27c-047acc373325.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4663-75c9-b27c-047acc373325",
        "storage_key": "property/6767906449165612/019d2709-4663-75c9-b27c-047acc373325.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-resler-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6043336805477920695&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.8521386",
      "poi_longitude": "-106.5560424",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-833-7867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTk4goz43YYRty-OPM4-3lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bc9d6e38-91a6-436a-9861-751247898122",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "El Paso Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "6910 N Mesa St Ste H Suite D, El Paso, TX 79912, USA",
      "poi_short_description": "Gymnastics center with USA Gymnastics-certified coaches offering classes for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-47f0-7554-b73e-9acf3064c135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-47f0-7554-b73e-9acf3064c135",
        "storage_key": "property/6767906449165612/019d2709-47f0-7554-b73e-9acf3064c135.webp",
        "width": 1008,
        "height": 567
      },
      "poi_business_url": "https://elpasogymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1102495125243281967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-gymnastics",
      "poi_latitude": "31.8356392",
      "poi_longitude": "-106.5482103",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-581-3476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5c10-7059-b1ac-5f75caccec11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c10-7059-b1ac-5f75caccec11",
        "storage_key": "property/6767906449165612/019d2709-5c10-7059-b1ac-5f75caccec11.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg6HzWWX43YYRL8K5onnZTA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_50384054-8602-48a6-b316-51cfb0d2443a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "981 N Resler Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Gym chain with free weights and cardio machines, plus group fitness classes and saunas.",
      "poi_long_description": "People say this fitness center offers a decent amount of equipment and has friendly staff.\n\nOther reviews mention the bathrooms can be outdated and the equipment can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-485f-72d8-a365-72f6146ce62a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-485f-72d8-a365-72f6146ce62a",
        "storage_key": "property/6767906449165612/019d2709-485f-72d8-a365-72f6146ce62a.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-resler/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7817928767867659509&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.86318139999999",
      "poi_longitude": "-106.5590516",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-760-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99A4Bwz53YYR9SQPEMvcfmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_5b2a231b-c6db-442f-b960-6fac599ff312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "El Paso Animal Urgent Care West",
      "poi_type": "Health and Wellness",
      "poi_address": "5500 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-4b25-734a-bf1f-09f6a22eb929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4b25-734a-bf1f-09f6a22eb929",
        "storage_key": "property/6767906449165612/019d2709-4b25-734a-bf1f-09f6a22eb929.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://elpasoanimalurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8021225143916288949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-animal-urgent-care-west",
      "poi_latitude": "31.8592417",
      "poi_longitude": "-106.575303",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-301-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-crCu353YYRtduPJsUdUW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_d773058d-2e92-42fd-ae80-5ebaf97ffe96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Las Palmas Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 N Oregon St, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-4c23-75bc-8849-dfd3c3bf55e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4c23-75bc-8849-dfd3c3bf55e9",
        "storage_key": "property/6767906449165612/019d2709-4c23-75bc-8849-dfd3c3bf55e9.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://laspalmasdelsolhealthcare.com/locations/las-palmas-medical-center/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7797277200056017172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-palmas-medical-center",
      "poi_latitude": "31.7699653",
      "poi_longitude": "-106.4987868",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 915-521-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604d-77ab-ad78-2808014f9f75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604d-77ab-ad78-2808014f9f75",
        "storage_key": "property/6767906449165612/019d2709-604d-77ab-ad78-2808014f9f75.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3k-QVdY54YRFGGXPE1-NWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e7ed9f19-2c74-42f8-8fdc-390ea387deed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "The Hospitals of Providence Transmountain Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 Woodrow Bean Transmountain Dr, El Paso, TX 79911, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-4c8c-772d-a79a-9e3f1e73bdb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4c8c-772d-a79a-9e3f1e73bdb7",
        "storage_key": "property/6767906449165612/019d2709-4c8c-772d-a79a-9e3f1e73bdb7.webp",
        "width": 1280,
        "height": 708
      },
      "poi_business_url": "https://www.thehospitalsofprovidence.com/locations/detail/transmountain-campus/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-thop-transmountain-campus&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12825019548281900470&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-hospitals-of-providence-transmountain-campus",
      "poi_latitude": "31.9044828",
      "poi_longitude": "-106.5650394",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-877-8136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604d-77ab-ad78-2808014f9f75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604d-77ab-ad78-2808014f9f75",
        "storage_key": "property/6767906449165612/019d2709-604d-77ab-ad78-2808014f9f75.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAdR1DTz_3YYRto3ITFSf-7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0451bb06-97cb-4db3-93be-41ee56997455",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Tom Mays Park Access Rd, El Paso, TX 79911, USA",
      "poi_short_description": "Vast state park featuring caves to explore, mountain trails and an amphitheater.",
      "poi_long_description": "People say this state park offers well-maintained hiking trails with breathtaking views, and opportunities for bird watching, picnicking, and camping. They highlight the easy and quick payment process for fees and parking, and the availability of picnic areas. They also like the friendly and helpful staff at the visitor center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-4d88-728f-8e22-f5046494b246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4d88-728f-8e22-f5046494b246",
        "storage_key": "property/6767906449165612/019d2709-4d88-728f-8e22-f5046494b246.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/franklin-mountains",
      "poi_directions_map_url": "https://maps.google.com/?cid=2199656840794880227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.9105609",
      "poi_longitude": "-106.518116",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-444-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6398-72c2-b22c-211aadbca5a6",
        "storage_key": "property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc0ThtdV54YR4zhWDz7Ahh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_8e59a44a-687c-4f2e-8036-4727f4fa880e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Copia St, El Paso, TX 79930, USA",
      "poi_short_description": "Park featuring hills and shaded areas, an ice-cream truck, a playground and tennis courts for activities like walking and picnics.",
      "poi_long_description": "People say this city park offers plenty of grass for picnics and games, a playground, and shade from numerous trees. They highlight the peaceful and relaxing vibe, and the well-maintained grounds. They also like the nearby ice cream truck and library branch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5049-7198-8fca-2ad2a7597b69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5049-7198-8fca-2ad2a7597b69",
        "storage_key": "property/6767906449165612/019d2709-5049-7198-8fca-2ad2a7597b69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=615165719072263059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "31.7894065",
      "poi_longitude": "-106.4571558",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6398-72c2-b22c-211aadbca5a6",
        "storage_key": "property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_YWrJNZ54YRk8tMU_aBiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1cd217ad-814c-4e10-a688-9a85530bb03e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "El Paso Municipal Rose Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3418 Aurora Ave, El Paso, TX 79930, USA",
      "poi_short_description": "Peaceful oasis featuring different varieties of roses and other flowers, with benches and a fountain.",
      "poi_long_description": "People say this garden offers a wide variety of beautiful roses and other flowers. They highlight the peaceful and serene atmosphere, perfect for walking, sitting, and meditation. They also like the well-maintained pathways and shaded seating areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-51c5-7160-b1f5-a42ebe2ee282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-51c5-7160-b1f5-a42ebe2ee282",
        "storage_key": "property/6767906449165612/019d2709-51c5-7160-b1f5-a42ebe2ee282.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "https://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16475470708097522831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-municipal-rose-garden",
      "poi_latitude": "31.7928257",
      "poi_longitude": "-106.4530369",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6398-72c2-b22c-211aadbca5a6",
        "storage_key": "property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT37fuJJZ54YRj5yBd1GhpOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_31a3e945-0632-4368-b747-7be07ef2afdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Skyline Optimist Youth Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5050 Yvette Ave, El Paso, TX 79924, USA",
      "poi_short_description": "Recreational area featuring picnic tables, a playground, baseball fields, and basketball and tennis courts.",
      "poi_long_description": "People say this park offers well-maintained baseball fields, pickleball courts, tennis courts, and a playground. They highlight the spacious, clean, and green environment with plenty of parking. They also like the clean and stocked portable toilets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-50dc-73fa-8ccb-aa8aab92931e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-50dc-73fa-8ccb-aa8aab92931e",
        "storage_key": "property/6767906449165612/019d2709-50dc-73fa-8ccb-aa8aab92931e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks-and-recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9478345246637154744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "skyline-optimist-youth-park",
      "poi_latitude": "31.8933202",
      "poi_longitude": "-106.4251592",
      "poi_miles_from_property": "18.4",
      "poi_walking_minutes": "6 hours 44 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 915-212-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6398-72c2-b22c-211aadbca5a6",
        "storage_key": "property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4da1gERR54YRuOFRjMjYiYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_409c924b-0d6c-4e74-90d9-34ff0c8f2874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Braden Aboud Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4325 River Bend Dr, El Paso, TX 79922, USA",
      "poi_short_description": "Shady park hosting baseball games and sporting a playground, skate park and splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-529e-755a-be7d-b9253e342812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-529e-755a-be7d-b9253e342812",
        "storage_key": "property/6767906449165612/019d2709-529e-755a-be7d-b9253e342812.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=8373575647336361708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "braden-aboud-memorial-park",
      "poi_latitude": "31.8215355",
      "poi_longitude": "-106.5734406",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6398-72c2-b22c-211aadbca5a6",
        "storage_key": "property/6767906449165612/019d2709-6398-72c2-b22c-211aadbca5a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD8kFLDb43YYR7G5Yp6_qNHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_58f9952c-2d03-42fe-b34a-a3519a1ede04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "TransPerfect Connect",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1015 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5551-77ba-8898-22da2186a2a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5551-77ba-8898-22da2186a2a3",
        "storage_key": "property/6767906449165612/019d2709-5551-77ba-8898-22da2186a2a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.transperfectconnect.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17503557915821498174&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "transperfect-connect",
      "poi_latitude": "31.8540386",
      "poi_longitude": "-106.5409878",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-289-9425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGydw0WT53YYRPl8Exi8h6fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_efaa9f6f-4f81-4565-b9af-0a48823d2750",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Fort Bliss Family and MWR",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Building 11, Pershing Rd, Fort Bliss, TX 79916, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bliss.armymwr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16320776352191715737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-family-and-mwr",
      "poi_latitude": "31.8066444",
      "poi_longitude": "-106.4355472",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 915-568-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7qMsRxa54YRmZn7Ap8Lf-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_93383eac-79da-400a-a129-4d972720cbb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "MPD Bldg 1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Fort Bliss, TX 79906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-567e-7749-9098-057d0bed3ac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-567e-7749-9098-057d0bed3ac1",
        "storage_key": "property/6767906449165612/019d2709-567e-7749-9098-057d0bed3ac1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=472201838689572878&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mpd-bldg-1",
      "poi_latitude": "31.8059017",
      "poi_longitude": "-106.435414",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 915-568-7679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC0m1hBxa54YRDthgCRKZjQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d5832726-2967-4e25-9f53-b2cc08c0ef7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Sunland Park City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 McNutt Rd A, Sunland Park, NM 88063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-56f1-759a-85b4-d18f0070d0b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-56f1-759a-85b4-d18f0070d0b9",
        "storage_key": "property/6767906449165612/019d2709-56f1-759a-85b4-d18f0070d0b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sunlandpark-nm.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9553831288229126832&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sunland-park-city-hall",
      "poi_latitude": "31.7967041",
      "poi_longitude": "-106.5563875",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 575-589-7565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-5fb6-72d9-8c30-27af483976ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5fb6-72d9-8c30-27af483976ee",
        "storage_key": "property/6767906449165612/019d2709-5fb6-72d9-8c30-27af483976ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoS02m_P33YYRsOLoMvAGloQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_a0f237f7-2e62-42b3-8a92-05c7b0fc1dc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Building 919c",
      "poi_type": "Major Employers & Offices",
      "poi_address": "919 Cassidy Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-57af-70cc-8ab7-b967c31704cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-57af-70cc-8ab7-b967c31704cc",
        "storage_key": "property/6767906449165612/019d2709-57af-70cc-8ab7-b967c31704cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7505436383675279397&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "building-919c",
      "poi_latitude": "31.81151479999999",
      "poi_longitude": "-106.4278738",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-604b-7520-bdfc-d74ca52310df",
        "storage_key": "property/6767906449165612/019d2709-604b-7520-bdfc-d74ca52310df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5XlRZg9a54YRJehBHaCqKGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4a63843c-0fc1-4f16-a52d-645343d40c30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Western Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "530 Thunderbird Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://westernhills.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16557716768082756121&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "western-hills-elementary-school",
      "poi_latitude": "31.8414541",
      "poi_longitude": "-106.5227464",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-236-3850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0caf-71ca-a4d4-672bd1f159f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0caf-71ca-a4d4-672bd1f159f9",
        "storage_key": "property/6767906449165612/019cfb43-0caf-71ca-a4d4-672bd1f159f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeTGw1s9X54YRGQIajazTyOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_09bf3d53-5998-4460-8384-da443b2f8c71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Coronado High School",
      "poi_type": "Education",
      "poi_address": "100 Champions Pl, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-ab15-70fe-af90-c4c532cd8d3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ab15-70fe-af90-c4c532cd8d3f",
        "storage_key": "property/6767906449165612/019d7912-ab15-70fe-af90-c4c532cd8d3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://coronado.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14130504508255682606&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "coronado-high-school",
      "poi_latitude": "31.8370723",
      "poi_longitude": "-106.5467083",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-236-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0caf-71ca-a4d4-672bd1f159f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0caf-71ca-a4d4-672bd1f159f9",
        "storage_key": "property/6767906449165612/019cfb43-0caf-71ca-a4d4-672bd1f159f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCSIuemX43YYRLsCiz_uiGcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_edc99c8f-94e4-442b-851c-7c47c1abe6aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Silva Magnet High School",
      "poi_type": "Education",
      "poi_address": "121 Val Verde St EPISD, El Paso, TX 79905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://silva.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7873586719222167734&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "silva-magnet-high-school",
      "poi_latitude": "31.7690451",
      "poi_longitude": "-106.4331483",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 915-236-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0caf-71ca-a4d4-672bd1f159f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0caf-71ca-a4d4-672bd1f159f9",
        "storage_key": "property/6767906449165612/019cfb43-0caf-71ca-a4d4-672bd1f159f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHZCZxNNb54YRtnh4s2eZRG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3aa464cd-fbe8-4572-96fb-fb83f3a936ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Transmountain Early College High School",
      "poi_type": "Education",
      "poi_address": "9570 Gateway Blvd N, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-abb4-75cd-8c76-fcd92e55a854.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-abb4-75cd-8c76-fcd92e55a854",
        "storage_key": "property/6767906449165612/019d7912-abb4-75cd-8c76-fcd92e55a854.webp",
        "width": 600,
        "height": 261
      },
      "poi_business_url": "https://www.episd.org/tmechs",
      "poi_directions_map_url": "https://maps.google.com/?cid=4469076188752141114&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "transmountain-early-college-high-school",
      "poi_latitude": "31.8843717",
      "poi_longitude": "-106.4382406",
      "poi_miles_from_property": "17.4 mi",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 915-236-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0caf-71ca-a4d4-672bd1f159f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0caf-71ca-a4d4-672bd1f159f9",
        "storage_key": "property/6767906449165612/019cfb43-0caf-71ca-a4d4-672bd1f159f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ46lwtUpR54YROlu6kB1ZBT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1006c905-5864-4e2a-86f6-78e23a594e65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "5630 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-af92-703c-8f19-cff295708e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-af92-703c-8f19-cff295708e89",
        "storage_key": "property/6767906449165612/019d7912-af92-703c-8f19-cff295708e89.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/18486",
      "poi_directions_map_url": "https://maps.google.com/?cid=6767909487400781321&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "31.86449",
      "poi_longitude": "-106.57496",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-845-5069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-ff51-73ab-890e-798e9babe2cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-ff51-73ab-890e-798e9babe2cd",
        "storage_key": "property/6767906449165612/019d7912-ff51-73ab-890e-798e9babe2cd.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJZx8jmfD53YYRCQaFJNJx7F0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_d3db7f4b-ddbf-4f81-b2ab-624b3ee9b2b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Restaurants",
      "poi_address": "951 N Resler Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Neighborhood chain providing a selection of groceries, apparel, and home goods, plus a bakery and a pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-aaf8-739a-874f-e6e2814ce102.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-aaf8-739a-874f-e6e2814ce102",
        "storage_key": "property/6767906449165612/019d7912-aaf8-739a-874f-e6e2814ce102.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4366-el-paso-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1057835591954062526&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "31.8609833",
      "poi_longitude": "-106.5593278",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-875-0124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c7f-72f9-86c9-e02e15079634.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c7f-72f9-86c9-e02e15079634",
        "storage_key": "property/6767906449165612/019cfb43-0c7f-72f9-86c9-e02e15079634.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoQwtNJP43YYRvtwvwd0vrg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5ccdc543-0d0f-4aaa-b740-fd9153a5918a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Restaurants",
      "poi_address": "890 N Resler Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-890+n+resler+dr-el+paso-tx-79912/id=3570",
      "poi_directions_map_url": "https://maps.google.com/?cid=11196587216453298904&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "31.858981",
      "poi_longitude": "-106.556846",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-584-1359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c74-7684-9a3f-01a1c15703e7",
        "storage_key": "property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEUwV6pL43YYR2OpgVcBEYps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_ec29e2cf-8241-4ab2-ba0a-7ddd8af77339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Garden Center at The Home Depot",
      "poi_type": "Restaurants",
      "poi_address": "7545 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-b39b-729f-b1f5-cd6147b00f54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b39b-729f-b1f5-cd6147b00f54",
        "storage_key": "property/6767906449165612/019d7912-b39b-729f-b1f5-cd6147b00f54.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "https://www.homedepot.com/l/W-El-Paso/TX/El-Paso/79912/523/garden-center?emt=GCGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1013024114037543843&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garden-center-at-the-home-depot",
      "poi_latitude": "31.8357823",
      "poi_longitude": "-106.5633623",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-585-2319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0cb7-7139-9ca6-2e453614b180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0cb7-7139-9ca6-2e453614b180",
        "storage_key": "property/6767906449165612/019cfb43-0cb7-7139-9ca6-2e453614b180.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnfj3nlz43YYRo9McghD8Dg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden_center"
    },
    {
      "id": "custom_1d986ffd-1294-477d-ab49-0f857d3b3399",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Restaurants",
      "poi_address": "655 Sunland Park Dr Ste B, El Paso, TX 79912, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic options, snacks, and unique items not found in other stores. They highlight the clean and well-organized layout, and the fair prices, especially during sales. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-b402-7028-9c81-6b7a2effff38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b402-7028-9c81-6b7a2effff38",
        "storage_key": "property/6767906449165612/019d7912-b402-7028-9c81-6b7a2effff38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sprouts.com/store/tx/el-paso/el-paso",
      "poi_directions_map_url": "https://maps.google.com/?cid=6636959221749597832&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "31.82128599999999",
      "poi_longitude": "-106.5447502",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-833-3380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c7f-72f9-86c9-e02e15079634.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c7f-72f9-86c9-e02e15079634",
        "storage_key": "property/6767906449165612/019cfb43-0c7f-72f9-86c9-e02e15079634.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5467d5X54YRiEYjgT83G1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fd2697e8-bbe1-4f8f-a7f5-bd87369bc89f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Crave Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "6470 N Desert Blvd Suite K-101, El Paso, TX 79912, USA",
      "poi_short_description": "Funky, energetic spot offering an array of pub grub such as burgers plus wine, beer & cocktails.",
      "poi_long_description": "People say this brunch restaurant serves delicious breakfast selections, including churro waffles, blueberry pancakes, and the haystack breakfast. They also highlight the generous portions, relaxing atmosphere, and friendly service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-b5f5-709d-9c17-6b7ae0ad6058.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b5f5-709d-9c17-6b7ae0ad6058",
        "storage_key": "property/6767906449165612/019d7912-b5f5-709d-9c17-6b7ae0ad6058.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://cravekitchenandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16444968990115436097&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crave-kitchen-bar",
      "poi_latitude": "31.8878277",
      "poi_longitude": "-106.5816912",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-234-2559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c79-759e-9452-3074a6d879a6",
        "storage_key": "property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWKqpov43YYRQRYl1ipEOOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_4ddffc1b-2b53-4c49-8671-92c59bb4f3e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Zino's Greek & Mediterranean Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "7040 N Mesa St Ste H, El Paso, TX 79912, USA",
      "poi_short_description": "Sky-blue outpost in a strip mall cooking up gyros, kebabs & other Mediterranean standards.",
      "poi_long_description": "People say this Greek restaurant serves delicious gyros, chicken kabobs, and baklava. They highlight the fresh ingredients, flavorful dishes, and generous portions. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-b7b8-7589-a589-2331a0835ef4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b7b8-7589-a589-2331a0835ef4",
        "storage_key": "property/6767906449165612/019d7912-b7b8-7589-a589-2331a0835ef4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://zinos-greek.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3015053432468128627&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "zino-s-greek-mediterranean-cuisine",
      "poi_latitude": "31.8370264",
      "poi_longitude": "-106.5523867",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-584-8166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c79-759e-9452-3074a6d879a6",
        "storage_key": "property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbYtCmb43YYRc8MVVR-f1yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_eacd459f-a1d0-4d0c-9e8b-925ed0f1fb9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Cafe Italia",
      "poi_type": "Restaurants",
      "poi_address": "6705 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "This tiny Italian eatery with a simple menu of wood-fired pizzas & pastas makes its own mozzarella.",
      "poi_long_description": "People say this Italian restaurant serves delicious, hand-made pizza with generous toppings and brick-oven dough. They highlight the cozy and welcoming atmosphere, and the great food and service. They also like that it's a great place to enjoy with family and that it's BYOB.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-bb30-72c5-aade-3bc9066696cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bb30-72c5-aade-3bc9066696cf",
        "storage_key": "property/6767906449165612/019d7912-bb30-72c5-aade-3bc9066696cf.webp",
        "width": 1280,
        "height": 788
      },
      "poi_business_url": "http://www.elpasocafeitalia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4524975017342297449&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cafe-italia",
      "poi_latitude": "31.8337283",
      "poi_longitude": "-106.5431581",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-832-0587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c79-759e-9452-3074a6d879a6",
        "storage_key": "property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJncF5BXH43YYRaWU0zs3wyz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_53b6a7b6-3d97-420e-a906-32f3eb16f7b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Sun garden chinese bistro",
      "poi_type": "Restaurants",
      "poi_address": "6600 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "A menu featuring traditional Chinese, family-style dishes in a modern setting with Asian decor.",
      "poi_long_description": "People say this Chinese restaurant serves delicious Salt & Pepper Shrimp and offers a great variety of menu options. They also highlight the good value, comfortable atmosphere, and friendly service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-bdd5-759a-83d7-73c494227772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bdd5-759a-83d7-73c494227772",
        "storage_key": "property/6767906449165612/019d7912-bdd5-759a-83d7-73c494227772.webp",
        "width": 1260,
        "height": 1280
      },
      "poi_business_url": "https://www.sungardenchinesebistro.com/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=1995058091747878794&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sun-garden-chinese-bistro",
      "poi_latitude": "31.8344472",
      "poi_longitude": "-106.5403416",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-585-8898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c79-759e-9452-3074a6d879a6",
        "storage_key": "property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Zkp1Hb43YYRiqfmoMPerxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_72c9cbb6-9b96-4d12-ad82-85bb7a5d18a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Peter Piper Pizza",
      "poi_type": "Restaurants",
      "poi_address": "119 Balboa Rd, El Paso, TX 79912, USA",
      "poi_short_description": "Lively, kid-oriented chain featuring pizza & wings along with dozens of arcade games.",
      "poi_long_description": "Lively, kid-oriented chain featuring pizza & wings along with dozens of arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-bd26-76d2-b722-c5b31d86a8ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bd26-76d2-b722-c5b31d86a8ff",
        "storage_key": "property/6767906449165612/019d7912-bd26-76d2-b722-c5b31d86a8ff.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://locations.peterpiperpizza.com/tx/elpaso/119-n-balboa-rd?utm_source=Google&utm_medium=Rio",
      "poi_directions_map_url": "https://maps.google.com/?cid=9351037358451774507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peter-piper-pizza",
      "poi_latitude": "31.8313484",
      "poi_longitude": "-106.5297732",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-581-4423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c79-759e-9452-3074a6d879a6",
        "storage_key": "property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zJadN5X54YRK9Ts_-6OxYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_24355e3e-c97b-426e-b61b-071c24576355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Pelican's Steak & Seafood",
      "poi_type": "Restaurants",
      "poi_address": "130 Shadow Mountain Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Relaxed mainstay serving rib-eye, lobster & bottomless salads along with tropical drinks & martinis.",
      "poi_long_description": "People say this seafood restaurant serves delicious steaks, seafood, and prime rib, with highlights including the grilled artichoke, wedge salad, and fish of the day. They highlight the comfortable and welcoming atmosphere, ideal for both relaxed dinners and special occasions. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-bee6-721d-acd3-39df9b4c7713.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bee6-721d-acd3-39df9b4c7713",
        "storage_key": "property/6767906449165612/019d7912-bee6-721d-acd3-39df9b4c7713.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://pelicans-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=816365703816841503&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pelican-s-steak-seafood",
      "poi_latitude": "31.8296244",
      "poi_longitude": "-106.5261266",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-581-1392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c79-759e-9452-3074a6d879a6",
        "storage_key": "property/6767906449165612/019cfb43-0c79-759e-9452-3074a6d879a6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcITn91X54YRH4nQRkhQVAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_ff071a73-4ea2-4350-913e-6b6a9279f05f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Coronado Country Club",
      "poi_type": "Entertainment",
      "poi_address": "1044 Broadmoor Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Relaxed club featuring a golf course, gym and tennis courts along with a pool.",
      "poi_long_description": "People say this country club offers amazing golf, delicious food, and beautiful mountain views. They highlight the welcoming atmosphere, family-friendly facilities, and year-round enjoyment. They also like the friendly staff and impeccable service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-c446-7080-958b-7713f5fb2afe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c446-7080-958b-7713f5fb2afe",
        "storage_key": "property/6767906449165612/019d7912-c446-7080-958b-7713f5fb2afe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://coronadocountryclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15518933510455318838&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "coronado-country-club",
      "poi_latitude": "31.8514199",
      "poi_longitude": "-106.5152336",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-584-1171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c74-7684-9a3f-01a1c15703e7",
        "storage_key": "property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ5X4CstX54YRNlmYD85TXtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_60c1e2d5-8423-4b43-bde3-97e8c54e89dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Entertainment",
      "poi_address": "Thunderbird Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Hiking area offering shade trees, sunset views, and a grilling area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-c745-74c8-965b-46d42d49540d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c745-74c8-965b-46d42d49540d",
        "storage_key": "property/6767906449165612/019d7912-c745-74c8-965b-46d42d49540d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3261171865648773583&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.8513961",
      "poi_longitude": "-106.5098828",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c74-7684-9a3f-01a1c15703e7",
        "storage_key": "property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0EHk0pW54YRzzl-i4gCQi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_758d13d2-ddfa-42b9-a211-2b76979838b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "McKelligon Canyon Park",
      "poi_type": "Entertainment",
      "poi_address": "1500 McKelligon Canyon Rd, El Paso, TX 79904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-cdbe-77bc-b99e-b2812fefe4da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cdbe-77bc-b99e-b2812fefe4da",
        "storage_key": "property/6767906449165612/019d7912-cdbe-77bc-b99e-b2812fefe4da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12631429928295635417&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mckelligon-canyon-park",
      "poi_latitude": "31.8414631",
      "poi_longitude": "-106.4857342",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 11 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c7a-73c8-8119-cfdef4e30122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c7a-73c8-8119-cfdef4e30122",
        "storage_key": "property/6767906449165612/019cfb43-0c7a-73c8-8119-cfdef4e30122.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCznzKJZX54YR2ZlMeZjaS68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_62cc1230-1f42-4460-97a8-5d703951354e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "El Paso Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "Train Station, 4001 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "220 African, American & Asian species residing in facsimiles of natural habitats in a 35-acre park.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including penguins, sea lions, giraffes, and wolves, with fun activities like a splash pad and playground for kids. They also highlight the friendly staff, clean facilities, and educational exhibits.\n\nSome reviews mention many exhibits can be closed for renovations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-c85c-725c-b89b-13882f8e1a5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c85c-725c-b89b-13882f8e1a5e",
        "storage_key": "property/6767906449165612/019d7912-c85c-725c-b89b-13882f8e1a5e.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.elpasozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9154948632860338008&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-zoo-and-botanical-gardens",
      "poi_latitude": "31.7690489",
      "poi_longitude": "-106.4448897",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 915-212-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c74-7684-9a3f-01a1c15703e7",
        "storage_key": "property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7ASQX5Z54YRWKeWzkbpDH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_dc092e27-59c0-47fb-90fe-98ba5aacb7a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Sunland Park Racetrack & Casino",
      "poi_type": "Entertainment",
      "poi_address": "1200 Futurity Dr, Sunland Park, NM 88063, USA",
      "poi_short_description": "Entertainment complex featuring a track for horse racing, casino with slots & 2 restaurants.",
      "poi_long_description": "People say this casino offers a variety of gambling options, including slots, video poker, electronic table games, and horse racing. They also highlight the friendly and helpful staff, and the fun and exciting atmosphere.\n\nOther reviews mention the casino can be smoky.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-d429-772a-a454-31ba98e776f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d429-772a-a454-31ba98e776f0",
        "storage_key": "property/6767906449165612/019d7912-d429-772a-a454-31ba98e776f0.webp",
        "width": 537,
        "height": 420
      },
      "poi_business_url": "http://www.sunland-park.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10680450856454078792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunland-park-racetrack-casino",
      "poi_latitude": "31.8048639",
      "poi_longitude": "-106.5598271",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 575-874-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c74-7684-9a3f-01a1c15703e7",
        "storage_key": "property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9ClnCH43YYRSEH2a3eVOJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_179be272-157d-41f1-b476-b7d97f1c4978",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "El Paso Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1 Arts Festival Plaza, El Paso, TX 79901, USA",
      "poi_short_description": "Works in 5 galleries reflect the area's American, Mexican & European roots.",
      "poi_long_description": "People say this museum offers a unique and diverse art experience, with some great historical pieces and student art. They highlight the free admission and the well-maintained, clean space. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-df5c-759b-8512-9cf38c147dbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-df5c-759b-8512-9cf38c147dbc",
        "storage_key": "property/6767906449165612/019d7912-df5c-759b-8512-9cf38c147dbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epma.art/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17054373816264367256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-museum-of-art",
      "poi_latitude": "31.7585876",
      "poi_longitude": "-106.4902692",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 915-212-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7913-010a-73bb-9b28-4bfcff0c7cb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-010a-73bb-9b28-4bfcff0c7cb2",
        "storage_key": "property/6767906449165612/019d7913-010a-73bb-9b28-4bfcff0c7cb2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxWj_B1Z54YRmBwpwaBOrew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_fcbfeec6-0685-435c-9734-3a84043766a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Hueco Tanks State Park & Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "6900 Hueco Tanks Road No. 1, El Paso, TX 79938, USA",
      "poi_short_description": "This park offers guided & self-led tours of ancient rock imagery, plus picnic spots & 20 campsites.",
      "poi_long_description": "People say this state park offers amazing views, unique ecosystems, and opportunities for hiking, rock climbing, and camping. They highlight the beautiful natural setting, the interesting history and petroglyphs, and the well-marked trails. They also like the knowledgeable and helpful park rangers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-e353-75b8-8ca7-b4eec6a0f9d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e353-75b8-8ca7-b4eec6a0f9d1",
        "storage_key": "property/6767906449165612/019d7912-e353-75b8-8ca7-b4eec6a0f9d1.webp",
        "width": 1025,
        "height": 1280
      },
      "poi_business_url": "http://tpwd.texas.gov/state-parks/hueco-tanks",
      "poi_directions_map_url": "https://maps.google.com/?cid=9351193483496823858&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hueco-tanks-state-park-historic-site",
      "poi_latitude": "31.9163705",
      "poi_longitude": "-106.0434449",
      "poi_miles_from_property": "41.3 mi",
      "poi_walking_minutes": "15 hours 17 mins",
      "poi_biking_minutes": "3 hours 54 mins",
      "poi_driving_minutes": "1 hour 9 mins",
      "poi_business_phone": "+1 915-857-1135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c7a-73c8-8119-cfdef4e30122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c7a-73c8-8119-cfdef4e30122",
        "storage_key": "property/6767906449165612/019cfb43-0c7a-73c8-8119-cfdef4e30122.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6_KTFbsw54YRMpzGse0cxoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_a82e6ca1-b5cf-4a13-ad31-e38ccf05a38d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "The Plaza Theatre",
      "poi_type": "Entertainment",
      "poi_address": "125 W Mills Ave, El Paso, TX 79901, USA",
      "poi_short_description": "Renovated 1930s space, now offering live performances, an original Wurlitzer organ & weekly tours.",
      "poi_long_description": "People say this performing arts theater offers a variety of shows, including Broadway productions, film festivals, and concerts. They highlight the beautiful architecture, historic value, and cozy vibes, as well as the comfortable seating and superb acoustics. They also like the attentive and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019d7912-f339-77a6-b159-6d81b3449d4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f339-77a6-b159-6d81b3449d4a",
        "storage_key": "property/6767906449165612/019d7912-f339-77a6-b159-6d81b3449d4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://elpasolive.com/venues/plaza-theatre",
      "poi_directions_map_url": "https://maps.google.com/?cid=7876941664598924440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-plaza-theatre",
      "poi_latitude": "31.7584203",
      "poi_longitude": "-106.489331",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-231-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-0c74-7684-9a3f-01a1c15703e7",
        "storage_key": "property/6767906449165612/019cfb43-0c74-7684-9a3f-01a1c15703e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0mkof1Y54YRmJzkyrWEUG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_f2b82f14-3e3d-4a25-8a8d-2b5c7e53700a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Morehead Middle School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "morehead-middle-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_de37b5ff-2686-4fcb-84e2-caf54bc50cb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "The Grape Italian Ristorante",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "the-grape-italian-ristorante",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_642d5c8e-7e43-426e-98f4-657ca1e65d42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Tom Mays Park",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "tom-mays-park",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b12249da-31c2-442d-a224-b037955e5939",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Alamo Drafthouse Cinema",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "alamo-drafthouse-cinema",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_462f2793-5ed5-4e02-a360-a286a85ea76f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "poi_name": "Fort Bliss and Old Ironsides Museum",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "fort-bliss-and-old-ironsides-museum",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_43a0c8c2c97a04bee2b73d7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_145aea778aa48115d22caa29",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_30d5585e0b757c9952b8df4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_188c5321e8b9123c9fd4e056",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9a1cbd567ea4ceed57d00f2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_95831c4e8406fde629dd18c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1fd4153f-70f2-4cc1-b9d6-63fff5f920fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "rating": "5.0",
      "name": "Luis",
      "text": "Asked to get repairs on my oven and ceiling fan. Repairs were done in a timely manner and was repaired quickly. Installed a new ceiling fan and fixed my oven in no time. Maintenance staff was friendly.",
      "date": "2025-06-29",
      "title": ""
    },
    {
      "id": "custom_be247e0e-2d34-4e8d-9945-a23634f9e933",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "rating": "5.0",
      "name": "Calvin Hernandez",
      "text": "I just moved here and I’m loving it! The management is amazing and super helpful. My family and I are feeling right at home. The pools, grills, and dog park, are all great too.",
      "date": "2025-07-10",
      "title": ""
    },
    {
      "id": "custom_e4ef5513-7e0e-44d4-ad98-bb3ec23e97bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "rating": "5.0",
      "name": "Jessica Alba",
      "text": "Been here about a month and it’s been so far so good no complaints moving here was easy. The staff is super friendly and took care of me. I started the process touring and getting all information about it in November 2024. They stayed in contact with me gave me the best options I could get up until moving time they were patient, respectful\n\nUpdate: had a maintenance request and was done in no time.",
      "date": "2025-03-28",
      "title": ""
    },
    {
      "id": "custom_a5d0d78f-0b26-48e6-bdb0-c14b9dde955f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "rating": "5.0",
      "name": "Zac Camp",
      "text": "The apartment was clean and put together well. The staff have been extremely friendly. We love it here!",
      "date": "2025-07-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_006b2a40-cb8b-4b4d-b898-4413c253ffe2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-9545-73aa-bb53-1c426ada6627.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of an outdoor swimming pool with lounge chairs and steps.",
        "public_id": "019cfb43-9545-73aa-bb53-1c426ada6627",
        "storage_key": "property/6767906449165612/019cfb43-9545-73aa-bb53-1c426ada6627.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Mountain Village Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62ff8bb2a8d3aa60094c1611&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-44b6-7519-9d57-d86b6db1c4cb",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "mountain-village-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612"
    },
    {
      "lead_collector_id": "019cf79e-452c-73ce-99e0-60505e177846",
      "lead_source": "LANDING_PAGE",
      "name": "mountain-village-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "pool-apartments-el-paso-tx",
      "search_query": "pool apartments in El Paso TX",
      "category": "Amenity",
      "h1_title": "Pool Apartments in El Paso, TX",
      "h2_subtitle": "Discover top-notch pool apartments in El Paso, TX. Mountain Village Apts. offers all the amenities you need for a refreshing lifestyle.",
      "page_copy": "Experience the ultimate in relaxation and leisure with the premier pool apartments in El Paso, TX, at Mountain Village Apts. Our community is nestled in the tranquil Thunderbird neighborhood, where you can enjoy spacious one- and two-bedroom floor plans. Perfectly complementing your lifestyle, our amenities include a refreshing swimming pool where you can unwind or meet with friends.\n\nBeyond our beautiful pool, Mountain Village Apts. also features a modern fitness center and an engaging playground, ensuring there's something for everyone. With convenient access to on-site laundry facilities and a package service, your comfort and convenience are our top priorities. Visit us today to find the perfect apartment that meets all your needs and more!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in El Paso, TX - Mountain Village",
      "seo_description": "Explore pool apartments in El Paso, TX at Mountain Village Apts. with spacious layouts and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "dog-park-apartments-thunderbird-el-paso",
      "search_query": "dog park apartments in Thunderbird El Paso",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Thunderbird El Paso",
      "h2_subtitle": "Looking for dog park apartments in Thunderbird El Paso? Mountain Village Apts. offers pet-friendly living with fantastic amenities.",
      "page_copy": "Welcome to Mountain Village Apts., where we offer exceptional dog park apartments in Thunderbird, El Paso. Our spacious one- and two-bedroom layouts provide comfort and style for you and your furry friend. Situated in the charming Thunderbird neighborhood, our community is designed to enhance your lifestyle with pet-friendly amenities.\n\nEmbrace the perfect blend of relaxation and fun with our modern facilities, including a state-of-the-art fitness center and an inviting playground. Our laundry facilities, package service, and 24-hour access cater to your convenience, making Mountain Village Apts. the ideal place to call home in El Paso. Come visit us and see how we can accommodate you and your pet!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Thunderbird El Paso",
      "seo_description": "Discover pet-friendly living at Mountain Village Apts. in Thunderbird El Paso, with amenities tailored for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "el-paso-apartments-fitness-center",
      "search_query": "El Paso apartments with fitness center",
      "category": "Amenity",
      "h1_title": "El Paso Apartments with Fitness Center",
      "h2_subtitle": "Find El Paso apartments with a fitness center at Mountain Village Apts. Enjoy modern amenities and comfortable living spaces.",
      "page_copy": "Welcome to Mountain Village Apts., where you can find the perfect El Paso apartments with a fitness center tailored to your active lifestyle. Nestled in the serene Thunderbird neighborhood, our community provides spacious one- and two-bedroom floor plans that prioritize comfort and style. Our state-of-the-art fitness center is just one of the many amenities designed to support your health and well-being.\n\nIn addition to our modern gym, Mountain Village Apts. offers a refreshing pool for relaxation and a fun-filled playground for all ages. Essential conveniences such as our on-site laundry facilities, package service, and 24-hour access ensure that all your needs are met. Discover how our amenities and welcoming community make Mountain Village Apts. the ideal place to call home in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "El Paso Apartments with Fitness Center - Mountain Village",
      "seo_description": "Explore El Paso apartments with a fitness center at Mountain Village, offering modern comforts and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-79912",
      "search_query": "air conditioned apartments zip 79912",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in 79912",
      "h2_subtitle": "Explore comfortable air-conditioned apartments in the 79912 area at Mountain Village Apts., where modern living pairs with essential conveniences.",
      "page_copy": "Discover the comfort of living in air-conditioned apartments in the 79912 area with Mountain Village Apts. Our community provides spacious one- and two-bedroom options, thoughtfully designed for ultimate comfort and style. Located in the desirable Thunderbird neighborhood of El Paso, each apartment is equipped with air conditioning to ensure a pleasant living environment year-round.\n\nBeyond climate-controlled comfort, Mountain Village Apts. offers a suite of amenities that enhance your lifestyle. Enjoy our swimming pool, cutting-edge fitness center, and inviting playground. With practical features like on-site laundry facilities, package service, and around-the-clock access, you'll find everything you need right at your doorstep. Experience the perfect blend of modern amenities and convenient living at Mountain Village Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in 79912 - Mountain Village",
      "seo_description": "Find air-conditioned apartments in the 79912 zip code at Mountain Village Apts. Enjoy comfortable living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "luxury-apartments-playground-el-paso",
      "search_query": "luxury apartments with playground in El Paso",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Playground in El Paso",
      "h2_subtitle": "Discover luxury apartments with a playground in El Paso at Mountain Village Apts. Experience upscale living tailored for families.",
      "page_copy": "Welcome to Mountain Village Apts., where luxury apartments with a playground in El Paso are beautifully crafted to meet your family’s needs. Nestled in the serene Thunderbird neighborhood, our spacious one- and two-bedroom floor plans blend elegance and comfort. The welcoming playground is perfect for family fun, providing a vibrant community atmosphere.\n\nIn addition to our family-friendly spaces, Mountain Village Apts. features premium amenities, including a refreshing pool and a state-of-the-art fitness center. With essential conveniences such as laundry facilities, package service, and 24-hour access, our community ensures an elevated living experience. Discover the charm and luxury that Mountain Village Apts. offers in the heart of El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Playground in El Paso",
      "seo_description": "Discover luxury living at Mountain Village Apts. in El Paso, featuring upscale amenities and a inviting playground.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-el-paso-tx",
      "search_query": "one bedroom apartments in El Paso TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in El Paso, TX",
      "h2_subtitle": "Find the perfect one bedroom apartment in El Paso, TX at Mountain Village Apts. Experience comfort and modern living today.",
      "page_copy": "Explore the charm and convenience of one bedroom apartments in El Paso, TX at Mountain Village Apts. Designed with both comfort and style in mind, our spacious one-bedroom floor plans provide an ideal living space for individuals or couples. Located in the picturesque Thunderbird neighborhood, our community offers a serene and welcoming environment.\n\nMountain Village Apts. is more than just a place to live—it's a destination. Enjoy premium amenities such as our state-of-the-art fitness center, a refreshing swimming pool, and essential services like on-site laundry facilities and package service. Our community ensures residents have everything they need for a modern, convenient lifestyle. Discover why Mountain Village Apts. is the perfect choice for one bedroom living in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in El Paso, TX - Mountain Village",
      "seo_description": "Discover one bedroom apartments at Mountain Village Apts. in El Paso, TX, offering modern amenities and comfortable living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-thunderbird-neighborhood",
      "search_query": "two bedroom rentals in Thunderbird neighborhood",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Thunderbird Area",
      "h2_subtitle": "Discover ideal two bedroom rentals in the Thunderbird neighborhood. Enjoy spacious living at Mountain Village Apts.",
      "page_copy": "Welcome to Mountain Village Apts., your destination for two bedroom rentals in the Thunderbird neighborhood. Our expansive two-bedroom apartments offer a perfect blend of comfort and convenience, making it an ideal choice for families or roommates looking for a modern living environment. Located in El Paso, each apartment is designed with your lifestyle in mind.\n\nAt Mountain Village Apts., residents can enjoy an array of stellar amenities, including a refreshing pool and a fully equipped fitness center, all within the charming Thunderbird community. With additional conveniences like laundry facilities, package service, and 24-hour access, our apartments provide everything needed for a comfortable and engaging living experience. Discover the benefits of making Mountain Village Apts. your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in Thunderbird - Mountain Village",
      "seo_description": "Explore two bedroom rentals in the Thunderbird neighborhood at Mountain Village Apts. Spacious living with modern amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "apartments-near-utep-thunderbird",
      "search_query": "apartments near University of Texas at El Paso Thunderbird",
      "category": "School",
      "h1_title": "Apartments Near University of Texas at El Paso",
      "h2_subtitle": "Discover convenient apartments near the University of Texas at El Paso in the Thunderbird neighborhood. Perfect for students and professionals.",
      "page_copy": "Located in the heart of the Thunderbird neighborhood, Mountain Village Apts. offers the ideal setting for those seeking apartments near the University of Texas at El Paso. Our community provides convenient access for students and professionals wanting to stay close to campus while enjoying upscale living.\n\nMountain Village Apts. features a variety of one- and two-bedroom floor plans, perfectly suited for individual or shared living. Enjoy modern amenities that enhance your lifestyle, including a refreshing pool and a state-of-the-art fitness center. Additional services like package handling and laundry facilities cater to your daily needs, making Mountain Village Apts. a prime choice for those seeking proximity to UTEP.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Texas at El Paso - Thunderbird",
      "seo_description": "Find perfect living at Mountain Village Apts., near UTEP in Thunderbird. Ideal for students with modern amenities and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "apartments-near-las-palmas-medical-center-el-paso",
      "search_query": "apartments near Las Palmas Medical Center El Paso",
      "category": "Hospital",
      "h1_title": "Apartments Near Las Palmas Medical Center",
      "h2_subtitle": "Find convenient living near Las Palmas Medical Center in El Paso at Mountain Village Apts. Perfect for healthcare professionals and hospital visitors.",
      "page_copy": "Mountain Village Apts. offers the ideal home base for those seeking apartments near Las Palmas Medical Center in El Paso. Our community provides easy access for healthcare professionals, patients, and visitors alike, ensuring a seamless blend of convenience and comfort.\n\nLocated in the serene Thunderbird neighborhood, Mountain Village Apts. features spacious one- and two-bedroom layouts equipped with premium amenities like a refreshing swimming pool and a modern fitness center. With essential services such as package handling and laundry facilities at your fingertips, our community supports a balanced lifestyle. Discover the comfort and accessibility of living at Mountain Village Apts. when you're near Las Palmas Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Las Palmas Medical Center - Mountain Village",
      "seo_description": "Discover Mountain Village Apts. near Las Palmas Medical Center, El Paso. Ideal living with modern amenities for healthcare staff and visitors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "mountain-village-apts-near-the-hospitals-of-providence-transmountain-campus",
      "search_query": "Mountain Village Apts near The Hospitals of Providence Transmountain Campus Thunderbird",
      "category": "Hospital",
      "h1_title": "Mountain Village Apts Near Providence Transmountain",
      "h2_subtitle": "Explore Mountain Village Apts near The Hospitals of Providence Transmountain Campus, located in the tranquil Thunderbird neighborhood.",
      "page_copy": "Welcome to Mountain Village Apts, conveniently located near The Hospitals of Providence Transmountain Campus in the peaceful Thunderbird neighborhood. Our community is perfect for healthcare professionals and families who desire the comfort of proximity, coupled with the serenity of our picturesque surroundings.\n\nMountain Village Apts offer spacious one- and two-bedroom homes equipped with modern amenities such as a sparkling pool and advanced fitness center, making it an ideal residence choice for those working at the hospital or visiting loved ones. With convenient services like package handling and vinyl flooring throughout, your transition to a comfortable lifestyle is effortless. Discover the benefits of living at Mountain Village Apts today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mountain Village Apts Near Providence Transmountain Campus",
      "seo_description": "Find home at Mountain Village Apts near The Hospitals of Providence Transmountain Campus in Thunderbird. Perfect for professionals with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "apartments-near-franklin-mountains-state-park-el-paso",
      "search_query": "apartments near Franklin Mountains State Park El Paso",
      "category": "Park",
      "h1_title": "Apartments Near Franklin Mountains State Park",
      "h2_subtitle": "Discover comfortable apartments near Franklin Mountains State Park in El Paso at Mountain Village Apts. Perfect for nature enthusiasts.",
      "page_copy": "Nestled near the stunning Franklin Mountains State Park in El Paso, Mountain Village Apts. offers an ideal living experience for those who crave outdoor adventures and natural beauty. Our community is perfect for anyone looking to enjoy easy access to hiking trails, scenic views, and the peaceful ambiance of the mountains.\n\nMountain Village Apts. boasts spacious one- and two-bedroom floor plans designed with modern living in mind. Enjoy our vibrant amenities, including a refreshing pool and a well-equipped fitness center. Whether you're an avid hiker or love observing the natural landscape, our proximity to Franklin Mountains State Park makes Mountain Village Apts. the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Franklin Mountains State Park, El Paso",
      "seo_description": "Live at Mountain Village Apts. near Franklin Mountains State Park, El Paso. Ideal for adventure lovers offering modern living and mountain access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "apartments-close-to-memorial-park-thunderbird-tx",
      "search_query": "apartments close to Memorial Park Thunderbird TX",
      "category": "Park",
      "h1_title": "Apartments Close to Memorial Park, Thunderbird",
      "h2_subtitle": "Discover our apartments close to Memorial Park in Thunderbird, TX at Mountain Village Apts. Offering ideal living spaces for outdoor lovers.",
      "page_copy": "Located a short drive from Memorial Park in Thunderbird, TX, Mountain Village Apts. provides the perfect home base for those who enjoy the great outdoors. Our community is designed for residents who appreciate easy access to all of Memorial Park’s recreational opportunities, including walking paths, picnic areas, and beautiful green spaces.\n\nMountain Village Apts. offers spacious one- and two-bedroom options that come with a range of desirable amenities like a refreshing pool and a state-of-the-art fitness center. Situated in a vibrant neighborhood with convenient access to local recreation, our community is ideal for those seeking modern living with the charm of proximity to nature. Explore Mountain Village Apts. for your next home near Memorial Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Memorial Park, Thunderbird, TX",
      "seo_description": "Find the convenience of Mountain Village Apts. near Memorial Park, Thunderbird, TX. Perfect for outdoor enthusiasts with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "skyline-optimist-youth-park-nearby-apartments-el-paso",
      "search_query": "Skyline Optimist Youth Park nearby apartments El Paso",
      "category": "Park",
      "h1_title": "Nearby Apartments to Skyline Optimist Youth Park",
      "h2_subtitle": "Discover apartments near Skyline Optimist Youth Park in El Paso at Mountain Village Apts. Ideal for families and outdoor fun.",
      "page_copy": "Located just a short distance from Skyline Optimist Youth Park in El Paso, Mountain Village Apts. offers families and individuals alike an inviting community to reside. Enjoy the convenience of having a beloved local park nearby, providing endless opportunities for outdoor activities and family gatherings.\n\nMountain Village Apts. features spacious one- and two-bedroom floor plans perfect for families seeking community engagement and recreation. Our amenities include a sparkling pool, a cutting-edge fitness center, and an engaging playground, making our living spaces ideal for those enjoying frequent visits to Skyline Optimist Youth Park. Experience the blend of comfort and convenience at Mountain Village Apts. for a fulfilling lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Skyline Optimist Youth Park, El Paso",
      "seo_description": "Live at Mountain Village Apts. near Skyline Optimist Youth Park, El Paso. Perfect for families with easy park access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165612",
      "source": "generator",
      "page_item_url": "braden-aboud-memorial-park-nearby-apartments-79912",
      "search_query": "Braden Aboud Memorial Park nearby apartments 79912",
      "category": "Park",
      "h1_title": "Apartments Near Braden Aboud Memorial Park",
      "h2_subtitle": "Explore nearby apartments to Braden Aboud Memorial Park in the 79912 area at Mountain Village Apts. Perfect for a vibrant lifestyle.",
      "page_copy": "Situated conveniently close to Braden Aboud Memorial Park in the 79912 ZIP code area, Mountain Village Apts. is your ideal choice for accessible, community-centered living. Experience the vibrant surroundings with the park nearby, offering plenty of recreational options like sports fields, playgrounds, and walking paths.\n\nMountain Village Apts. provides spacious one- and two-bedroom apartments that cater to those looking to be part of an active community. Enjoy an array of amenities including a pool and state-of-the-art fitness center. Proximity to Braden Aboud Memorial Park makes it easy to engage in outdoor activities while enjoying a comfortable home base in Mountain Village Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
      "featured_image_media": {
        "alt_text": "Mountain Village Apartment Homes leasing office exterior with signage.",
        "public_id": "019cfb42-eab4-761e-9fa9-439ea8e09444",
        "storage_key": "property/6767906449165612/019cfb42-eab4-761e-9fa9-439ea8e09444.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Braden Aboud Memorial Park 79912",
      "seo_description": "Mountain Village Apts. offers modern apartments near Braden Aboud Memorial Park in 79912. Enjoy robust amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5187"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-BZTWESH0S5"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151306"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/mountain-village/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NQZLM4C8"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165612/019d1bd8-cf63-778e-8993-cda134a16f3a.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-365-1975"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6480cd606aeed19252330a75"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjFHenZTb2d4YStNTFRCS1VRN0cwNEE9PSIsInZhbHVlIjoiU0V6ME9TTXB1ZG1pSzBsY3lMM1VqZz09IiwibWFjIjoiNDRjMGE5YTcwOGY0OTViZTQyNzk1MmFmZDY3NzMwZDA4OWE3ODhlZTE3NDlkOTY4OTBjMTA3ZGJjYzEzOWQyNCJ9"
    }
  ],
  "custom_qb_id": "5187",
  "custom_ga4_id": "G-BZTWESH0S5",
  "custom_repli_id": "10041151306",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/mountain-village/register/",
  "custom_google_gtm_id": "GTM-NQZLM4C8",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165612/019d1bd8-cf63-778e-8993-cda134a16f3a.pdf",
  "custom_ppc_tracking_phone_number": "800-365-1975",
  "custom_residentboost_apartment_id": "6480cd606aeed19252330a75",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjFHenZTb2d4YStNTFRCS1VRN0cwNEE9PSIsInZhbHVlIjoiU0V6ME9TTXB1ZG1pSzBsY3lMM1VqZz09IiwibWFjIjoiNDRjMGE5YTcwOGY0OTViZTQyNzk1MmFmZDY3NzMwZDA4OWE3ODhlZTE3NDlkOTY4OTBjMTA3ZGJjYzEzOWQyNCJ9"
};

export const generatedAt = '2026-08-27T21:37:48.459Z';
